/**
 * This file was auto-generated by openapi-typescript.
 * Do not make direct changes to the file.
 */

export type paths = {
    "/v1/validation/validate-address": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post: operations["AddressValidationController_validateAddress_v1"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/locations/{locationId}/permits/{agencyType}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put: operations["LocationPermitsController_updateAgencyTypePermit_v1"];
        post: operations["LocationPermitsController_createLocationPermit_v1"];
        delete: operations["LocationPermitsController_deleteAgencyTypePermit_v1"];
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/locations/{locationId}/permits": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["LocationPermitsController_getAllPermits_v1"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/locations/{locationId}/permits/history": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["LocationPermitsController_getPermitsHistory_v1"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/locations/{locationId}/permitting-comments": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["LocationPermittingCommentsController_getLocationPermittingComments_v1"];
        put?: never;
        post: operations["LocationPermittingCommentsController_addLocationPermittingComment_v1"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/locations/{locationId}/changes": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["LocationChangeController_getLocationChanges_v1"];
        put?: never;
        post: operations["LocationChangeController_createLocationChange_v1"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/locations/{locationId}/changes/{locationChangeId}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put: operations["LocationChangeController_updateLocationChange_v1"];
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/locations/{locationId}/deltas": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["LocationDeltasController_getDeltas_v1"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/locations/{locationId}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["LocationsController_getLocation_v1"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/locations/{locationId}/alarms": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["LocationAlarmsController_getAlarmSummaries_v1"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/locations/{locationId}/alarms/{alarmId}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["LocationAlarmsController_getAlarmDetails_v1"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/locations/{locationId}/alarms/{alarmId}/recordings/token": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post: operations["LocationAlarmRecordingsController_createToken_v1"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/monitoring-service-providers/{monitoringServiceProviderId}/locations/{transmitterCode}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["LocationIdProviderController_getLocationIdentifiersByTransmitterCode_v1"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/metrics": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post: operations["MetricsController_createMetric_v1"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/health": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["HealthController_check"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/health/liveness": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["HealthController_checkLiveness"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/health/readiness": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["HealthController_checkReadiness"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/health/startup": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["HealthController_checkStartup"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/locations/{locationId}/engagements/{engagementId}/token": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post: operations["LocationEngagementsController_createToken_v1"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/locations/{locationId}/engagements/{engagementId}/recordings/cameras/{cameraId}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["LocationEngagementsController_getRecordings_v1"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/locations/{locationId}/cameras": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["LocationCamerasController_getCameras_v1"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/locations/{locationId}/devices/camera/{deviceId}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch: operations["LocationCameraDeviceController_patchCameraDevice_v1"];
        trace?: never;
    };
    "/v1/search": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["SearchController_search_v1"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/locations/{locationId}/moderation-events/{eventId}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["ModerationController_getModerationEvents_v1"];
        put?: never;
        post?: never;
        delete: operations["ModerationController_deleteModerationEvent_v1"];
        options?: never;
        head?: never;
        patch: operations["ModerationController_updateModerationEvent_v1"];
        trace?: never;
    };
    "/v1/locations/{locationId}/moderation-events": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["ModerationController_getAllModerationEvents_v1"];
        put?: never;
        post: operations["ModerationController_createModerationEvent_v1"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/engagements/{engagementId}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["EngagementsController_getEngagement_v1"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/engagements": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["EngagementsController_getAllEngagements_v1"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/engagements/{engagementId}/activities": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["EngagementsController_getActivities_v1"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/engagements/{engagementId}/events": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["EngagementsController_getEngagementEvents_v1"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/locations/{locationId}/safe-words": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["SafeWordsController_getSafeWords_v1"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/locations/{locationId}/safe-words/{safeWordId}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put: operations["SafeWordsController_putSafeWord_v1"];
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/locations/{locationId}/monitoring": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put: operations["LocationMonitoringController_putMonitoring_v1"];
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/locations/{locationId}/contacts": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put: operations["LocationContactsController_putContacts_v1"];
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/locations/{locationId}/address": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put: operations["LocationAddressController_putAddress_v1"];
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/locations/{locationId}/dispatch-notes": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put: operations["LocationDispatchNotesController_updateDispatchNotes_v1"];
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/locations/{locationId}/certificates/monitoring": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["LocationCertificatesController_getLocationCertificate_v1"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/locations/{locationId}/certificates/monitoring/email": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post: operations["LocationCertificatesController_sendLocationCertificateEmail_v1"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/locations/{locationId}/template-id": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put: operations["LocationTemplateIdController_updateTemplateId_v1"];
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/monitoring-service-provider-locations/{locationId}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["MspLocationsController_getLocation_v1"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/locations/{locationId}/workflows": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["LocationWorkflowsController_getWorkflows_v1"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/monitoring-service-provider-locations/{locationId}/identifiers": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["MspLocationIdentifiersController_getMspIdentifiers_v1"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch: operations["MspLocationIdentifiersController_patchMspIdentifiers_v1"];
        trace?: never;
    };
    "/v1/specialists/{monitoringServiceProviderId}/{specialistId}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["SpecialistsController_getSpecialist_v1"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/specialists/{monitoringServiceProviderId}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["SpecialistsController_getAllSpecialists_v1"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/exclusion-rules/{id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["ExclusionRuleController_getExclusionRule_v1"];
        put?: never;
        post?: never;
        delete: operations["ExclusionRuleController_deleteExclusionRule_v1"];
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/exclusion-rules": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["ExclusionRuleController_getAllExclusionRules_v1"];
        put?: never;
        post: operations["ExclusionRuleController_createExclusionRule_v1"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
};
export type webhooks = Record<string, never>;
export type components = {
    schemas: {
        AddressValidation: {
            /**
             * @deprecated
             * @enum {string}
             */
            residenceType?: AddressValidationResidenceType;
            name?: string;
            street1: string;
            street2?: string;
            city: string;
            state: string;
            zip: string;
            county?: string;
            country: string;
        };
        AddressCorrection: {
            /** @enum {string} */
            type: AddressCorrectionType;
            /** @enum {string} */
            severity: AddressCorrectionSeverity;
            description: string;
        };
        AddressIssueDescription: {
            internal?: string;
            external: string;
        };
        AddressIssue: {
            /** @enum {string} */
            type: AddressIssueType;
            /** @enum {string} */
            severity: AddressIssueSeverity;
            description: components["schemas"]["AddressIssueDescription"];
        };
        AddressCandidate: {
            name?: string;
            street1?: string;
            street2?: string;
            city?: string;
            state?: string;
            zip?: string;
            zipPlus4?: string;
            county?: string;
            country?: string;
            /** @enum {string} */
            residentialDeliveryIndicator?: AddressCandidateResidentialDeliveryIndicator;
            /** @enum {string} */
            timeZone?: AddressCandidateTimeZone;
            corrections: components["schemas"]["AddressCorrection"][];
            issues: components["schemas"]["AddressIssue"][];
        };
        AddressValidationResult: {
            address: components["schemas"]["AddressValidation"];
            candidates: components["schemas"]["AddressCandidate"][];
        };
        CreateLocationPermit: {
            /** @enum {string} */
            source: CreateLocationPermitSource;
            permitNumber?: string;
            isNotNumbered?: boolean;
            /** Format: date */
            expirationDate?: string;
            isEternal?: boolean;
        };
        LocationPermitStatus: {
            hasAddressChanged?: boolean;
            hasSubscriptionReactivated?: boolean;
            hasLocationTypeChanged?: boolean;
            hasJurisdictionChanged?: boolean;
            haveAgencyRulesChanged?: boolean;
            hasJurisdictionPolicyChanged?: boolean;
            hasLocationOwnershipChanged?: boolean;
        };
        LocationPermit: {
            source: string;
            status?: components["schemas"]["LocationPermitStatus"];
            /** Format: date-time */
            createdAt: string;
            createdBy: string;
            /** Format: date-time */
            updatedAt: string;
            updatedBy: string;
            permitNumber?: string;
            isNotNumbered?: boolean;
            /** Format: date */
            expirationDate?: string;
            isEternal?: boolean;
        };
        LocationPermits: {
            police?: components["schemas"]["LocationPermit"];
            fire?: components["schemas"]["LocationPermit"];
            medical?: components["schemas"]["LocationPermit"];
        };
        LocationPermitHistoryDto: {
            isTombstone: boolean;
            /** @enum {string} */
            source: CreateLocationPermitSource;
            status?: components["schemas"]["LocationPermitStatus"];
            /** Format: date-time */
            createdAt: string;
            createdBy: string;
            /** Format: date-time */
            updatedAt: string;
            updatedBy: string;
            /** @enum {string} */
            changeType: LocationPermitHistoryDtoChangeType;
            permitNumber?: string;
            isNotNumbered?: boolean;
            /** Format: date */
            expirationDate?: string;
            isEternal?: boolean;
        };
        LocationPermitTombstoneDto: {
            isTombstone: boolean;
            /** Format: date-time */
            createdAt: string;
            createdBy: string;
            /** Format: date-time */
            updatedAt: string;
            updatedBy: string;
            /** @enum {string} */
            changeType: LocationPermitHistoryDtoChangeType;
        };
        LocationPermitHistories: {
            police: (components["schemas"]["LocationPermitHistoryDto"] | components["schemas"]["LocationPermitTombstoneDto"])[];
            fire: (components["schemas"]["LocationPermitHistoryDto"] | components["schemas"]["LocationPermitTombstoneDto"])[];
            medical: (components["schemas"]["LocationPermitHistoryDto"] | components["schemas"]["LocationPermitTombstoneDto"])[];
        };
        LocationPermittingCommentRequestDto: {
            content: string;
        };
        LocationPermittingCommentDto: {
            /** @example b3f19089-710f-4f65-b075-f76d1946f556 */
            id: string;
            content: string;
            /** Format: date-time */
            createdAt: string;
            createdBy: string;
            /** Format: date-time */
            updatedAt: string;
            updatedBy: string;
        };
        MonitoringLocationChangeAddress: {
            street1: string;
            street2?: string;
            postalCode: string;
            city: string;
            state?: string;
            county?: string;
            /** @enum {string} */
            country: MonitoringLocationChangeAddressCountry;
            crossStreet?: string;
            /** @enum {string} */
            propertyType: AddressValidationResidenceType;
            /** @enum {string} */
            timeZone: MonitoringLocationChangeAddressTimeZone;
            businessName?: string;
        };
        LocationChange: {
            /** Format: date-time */
            effectiveAt: string;
            address: components["schemas"]["MonitoringLocationChangeAddress"];
            /** @enum {string} */
            state: LocationChangeState;
            id: string;
            locationId: string;
            /** Format: date-time */
            createdAt: string;
            createdBy: string;
            /** Format: date-time */
            updatedAt: string;
            updatedBy: string;
        };
        CreateLocationChange: {
            /** Format: date-time */
            effectiveAt: string;
            address: components["schemas"]["MonitoringLocationChangeAddress"];
        };
        UpdateLocationChange: {
            /** Format: date-time */
            effectiveAt: string;
            address: components["schemas"]["MonitoringLocationChangeAddress"];
            /** @enum {string} */
            state: LocationChangeState;
        };
        PartialLocationAddress: {
            street1?: string;
            street2?: string;
            crossStreet?: string;
            city?: string;
            state?: string;
            zip?: string;
            county?: string;
            country?: string;
            /** @enum {string} */
            propertyType?: AddressValidationResidenceType;
            /**
             * @deprecated
             * @enum {number}
             */
            residenceType?: PartialLocationAddressResidenceType;
            /** @enum {string} */
            timeZone?: AddressCandidateTimeZone;
        };
        PartialPrimaryContactName: {
            firstName?: string;
            lastName?: string;
        };
        PartialPhone: {
            number?: string;
        };
        PartialPrimaryContact: {
            name?: components["schemas"]["PartialPrimaryContactName"];
            phone?: components["schemas"]["PartialPhone"];
        };
        PartialSecondaryContact: {
            name?: string;
            phone?: components["schemas"]["PartialPhone"];
        };
        PartialContacts: {
            primaryContacts?: components["schemas"]["PartialPrimaryContact"][];
            secondaryContacts?: components["schemas"]["PartialSecondaryContact"][];
        };
        PartialLocation: {
            id?: string;
            name?: string;
            baseStationSerialNumber?: string;
            address?: components["schemas"]["PartialLocationAddress"];
            contacts?: components["schemas"]["PartialContacts"];
            templateId?: string;
            dispatchNotes?: string;
            siteNumber?: string;
            account?: string;
            uid?: string;
        };
        LocationDeltaRecord: {
            /** @enum {string} */
            resource: LocationDeltaRecordResource;
            /** Format: date-time */
            updatedAt: string;
            updatedBy: string;
            from?: components["schemas"]["PartialLocation"];
            to?: components["schemas"]["PartialLocation"];
        };
        SafeWordDeltaRecord: {
            /** @enum {string} */
            resource: SafeWordDeltaRecordResource;
            /** Format: date-time */
            updatedAt: string;
            updatedBy: string;
            type: string;
        };
        PagedDeltaRecords: {
            items: (components["schemas"]["LocationDeltaRecord"] | components["schemas"]["SafeWordDeltaRecord"])[];
            nextToken?: string;
        };
        LocationUser: {
            userId: string;
            emailAddress?: string;
        };
        LocationFeatureConsent: {
            /** Format: date-time */
            acceptedAt?: string;
            acceptedBy?: string;
        };
        LocationFeature: {
            name: string;
            enabled: boolean;
            options?: Record<string, unknown>;
            consent?: components["schemas"]["LocationFeatureConsent"];
        };
        LocationAddress: {
            street1?: string;
            street2?: string;
            crossStreet?: string;
            city?: string;
            state?: string;
            zip?: string;
            county?: string;
            country?: string;
            /** @enum {string} */
            propertyType?: AddressValidationResidenceType;
            /**
             * @deprecated
             * @enum {number}
             */
            residenceType?: PartialLocationAddressResidenceType;
            /** @enum {string} */
            timeZone?: AddressCandidateTimeZone;
        };
        Map: Record<string, unknown>;
        LocationJurisdictionalRules: {
            permittingRules?: components["schemas"]["Map"];
        };
        Location: {
            id: string;
            user: components["schemas"]["LocationUser"];
            features: components["schemas"]["LocationFeature"][];
            name: string;
            street1?: string;
            street2?: string;
            city?: string;
            state?: string;
            zip?: string;
            county?: string;
            residenceType?: number;
            userId?: number;
            permits?: components["schemas"]["LocationPermits"];
            baseStationSerialNumber?: string;
            address?: components["schemas"]["LocationAddress"];
            jurisdictionalRules?: components["schemas"]["LocationJurisdictionalRules"];
        };
        SignalCode: {
            eventContactId: string;
            zoneId: string;
        };
        Sensor: {
            serial?: string;
            type?: number;
            name?: string;
        };
        AlarmSignal: {
            id?: string;
            signalCode: components["schemas"]["SignalCode"];
            sensor?: components["schemas"]["Sensor"];
        };
        MonitoringSpecialist: {
            id: string;
            name?: string;
        };
        AlarmMonitoringState: {
            /** @enum {string} */
            state: AlarmMonitoringStateState;
            monitoringServiceProviderId?: string;
            monitoringSpecialist?: components["schemas"]["MonitoringSpecialist"];
            /** @enum {string} */
            disposition?: AlarmMonitoringStateDisposition;
            /** Format: date-time */
            completedTimestamp?: string;
            /** @enum {string} */
            dispositionReason?: AlarmMonitoringStateDispositionReason;
        };
        PhoneNumber: {
            number: string;
            extension?: string;
            /** @enum {string} */
            type?: PhoneNumberType;
        };
        CustomerContact: {
            name?: string;
            phone: components["schemas"]["PhoneNumber"];
        };
        AlarmCustomerContactState: {
            contact: components["schemas"]["CustomerContact"];
            /** @enum {string} */
            state: AlarmCustomerContactStateState;
            /** @enum {string} */
            verificationState: AlarmCustomerContactStateVerificationState;
        };
        AlarmCustomerState: {
            /** @enum {string} */
            state: AlarmCustomerContactStateState;
            customerContacts?: components["schemas"]["AlarmCustomerContactState"][];
            /** @enum {string} */
            verificationState: AlarmCustomerContactStateVerificationState;
        };
        Agency: {
            /** @enum {string} */
            type: AgencyType;
            name?: string;
            phone?: components["schemas"]["PhoneNumber"];
        };
        Dispatch: {
            agency: components["schemas"]["Agency"];
            /** @enum {string} */
            state: DispatchState;
            /** @enum {string} */
            dispatchDeclinedReason?: DispatchDispatchDeclinedReason;
            /** @enum {string} */
            customerContactVerificationState: AlarmCustomerContactStateVerificationState;
        };
        AlarmDispatchState: {
            /** @enum {string} */
            state: DispatchState;
            dispatches?: components["schemas"]["Dispatch"][];
        };
        Attributes: {
            isCancellable: boolean;
            isElectronicallyCancellable: boolean;
            isAnnunciatedToCustomer: boolean;
            isIntrusionIncident: boolean;
            isOutdoorIncident: boolean;
            isPracticeModeEnabled?: boolean;
            isVisualVerificationEnabled?: boolean;
            isLiveGuardProtectionEnabled?: boolean;
            isOutdoorMonitoringEnabled?: boolean;
            isLocationNoActionEnabled?: boolean;
        };
        GoverningAlarmSignalEventContactId: {
            zone: string;
            event: string;
        };
        GoverningAlarmSignalEvent: {
            id: string;
            contactId: components["schemas"]["GoverningAlarmSignalEventContactId"];
        };
        AlarmSummary: {
            id: string;
            locationId: string;
            /** Format: date-time */
            createdTimestamp: string;
            /** Format: date-time */
            updatedTimestamp: string;
            calculatorVersion?: string;
            /** @enum {string} */
            category: AlarmSummaryCategory;
            triggeringSignal: components["schemas"]["AlarmSignal"];
            governingSignal: components["schemas"]["AlarmSignal"];
            monitoring: components["schemas"]["AlarmMonitoringState"];
            customer: components["schemas"]["AlarmCustomerState"];
            dispatch: components["schemas"]["AlarmDispatchState"];
            /** @enum {string} */
            disposition?: AlarmSummaryDisposition;
            attributes?: components["schemas"]["Attributes"];
            governingAlarmSignalEvent?: components["schemas"]["GoverningAlarmSignalEvent"];
        };
        PagedAlarmSummaries: {
            items: components["schemas"]["AlarmSummary"][];
            nextToken?: string;
        };
        TimelineAlarmEvent: {
            /** @enum {string} */
            type: TimelineAlarmEventType;
            id: string;
            /** Format: date-time */
            timestamp: string;
            /** Format: date-time */
            receivedTimestamp: string;
        };
        TimelineAlarmSignalEvent: {
            /** @enum {string} */
            type: TimelineAlarmSignalEventType;
            id: string;
            /** Format: date-time */
            timestamp: string;
            /** Format: date-time */
            receivedTimestamp: string;
            signalId?: string;
            signalCode: components["schemas"]["SignalCode"];
            sensor?: components["schemas"]["Sensor"];
            visualVerificationUrl?: string;
            holdDurationInMilliseconds?: number;
            monitoringSpecialist?: components["schemas"]["MonitoringSpecialist"];
            dispatchNote?: string;
        };
        TimelineMonitoringServiceProviderAlarmSignalEvent: {
            /** @enum {string} */
            type: TimelineMonitoringServiceProviderAlarmSignalEventType;
            id: string;
            /** Format: date-time */
            timestamp: string;
            /** Format: date-time */
            receivedTimestamp: string;
            monitoringServiceProviderId: string;
            monitoringServiceProviderEventId: string;
            monitoringServiceProviderAlarmId?: string;
            monitoringServiceProviderEvent: Record<string, unknown>;
            signalId?: string;
            signalCode: components["schemas"]["SignalCode"];
            sensor?: components["schemas"]["Sensor"];
            visualVerificationUrl?: string;
            holdDurationInMilliseconds?: number;
            /** @enum {string} */
            disposition?: AlarmMonitoringStateDisposition;
            /** @enum {string} */
            monitoringServiceProviderAccountStatus?: TimelineMonitoringServiceProviderAlarmSignalEventMonitoringServiceProviderAccountStatus;
        };
        TimelineMonitoringServiceProviderAsapMessageEvent: {
            /** @enum {string} */
            type: TimelineMonitoringServiceProviderAsapMessageEventType;
            id: string;
            /** Format: date-time */
            timestamp: string;
            /** Format: date-time */
            receivedTimestamp: string;
            monitoringServiceProviderId: string;
            monitoringServiceProviderEventId: string;
            monitoringServiceProviderAlarmId?: string;
            monitoringServiceProviderEvent: Record<string, unknown>;
            /** @enum {string} */
            messageType: TimelineMonitoringServiceProviderAsapMessageEventMessageType;
            details?: string;
        };
        TimelineMonitoringServiceProviderLocationIssueEvent: {
            /** @enum {string} */
            type: TimelineMonitoringServiceProviderLocationIssueEventType;
            id: string;
            /** Format: date-time */
            timestamp: string;
            /** Format: date-time */
            receivedTimestamp: string;
            monitoringServiceProviderId: string;
            monitoringServiceProviderEventId: string;
            monitoringServiceProviderAlarmId?: string;
            monitoringServiceProviderEvent: Record<string, unknown>;
            /** @enum {string} */
            locationIssue: TimelineMonitoringServiceProviderLocationIssueEventLocationIssue;
            details?: string;
        };
        AgencyCallRecipient: {
            /** @enum {string} */
            type: AgencyCallRecipientType;
            name?: string;
            phone?: components["schemas"]["PhoneNumber"];
            /** @enum {string} */
            agencyType: AgencyType;
        };
        CustomerContactCallRecipient: {
            /** @enum {string} */
            type: AgencyCallRecipientType;
            name?: string;
            phone?: components["schemas"]["PhoneNumber"];
        };
        OtherCallRecipient: {
            /** @enum {string} */
            type: AgencyCallRecipientType;
            name?: string;
            phone?: components["schemas"]["PhoneNumber"];
        };
        CallDetails: {
            recipient: components["schemas"]["AgencyCallRecipient"] | components["schemas"]["CustomerContactCallRecipient"] | components["schemas"]["OtherCallRecipient"];
            description?: string;
            /** @enum {string} */
            disposition?: CallDetailsDisposition;
        };
        TimelineMonitoringSpecialistEvent: {
            /** @enum {string} */
            type: TimelineMonitoringSpecialistEventType;
            id: string;
            /** Format: date-time */
            timestamp: string;
            /** Format: date-time */
            receivedTimestamp: string;
            monitoringServiceProviderId: string;
            monitoringServiceProviderEventId: string;
            monitoringServiceProviderAlarmId?: string;
            monitoringServiceProviderEvent: Record<string, unknown>;
            monitoringSpecialist: components["schemas"]["MonitoringSpecialist"];
            /** @enum {string} */
            action: TimelineMonitoringSpecialistEventAction;
            details?: string;
            callDetails?: components["schemas"]["CallDetails"];
            comment?: string;
            /** @enum {string} */
            disposition?: AlarmMonitoringStateDisposition;
        };
        RssiReading: {
            /** Format: date-time */
            timestamp: string;
            /** @description Received Signal Strength Indicator - a measurement of how well a device can hear a signal from an access point or router (value units are dBm) */
            value: number;
        };
        CameraStatus: {
            isOnline: boolean;
            state: string;
            /** @example 720p */
            resolution?: string;
            batteryPercentage?: number;
            rssi?: components["schemas"]["RssiReading"][];
        };
        CameraConnection: {
            isConnected: boolean;
            /** Format: date-time */
            lastLogin?: string;
            /** Format: date-time */
            lastLogout?: string;
        };
        Recording: {
            id: string;
            /** Format: date-time */
            timestamp: string;
            declaredDurationInSeconds: number;
            actualDurationInSeconds: number;
        };
        Camera: {
            uuid: string;
            name: string;
            model: string;
            supportedFeatures: components["schemas"]["SupportedFeatures"];
        };
        TimelineCameraRecordingQualityEvent: {
            /** @enum {string} */
            type: TimelineCameraRecordingQualityEventType;
            id: string;
            /** Format: date-time */
            timestamp: string;
            /** Format: date-time */
            receivedTimestamp: string;
            cameras: components["schemas"]["Camera"][];
            /** @enum {string} */
            trigger: TimelineCameraRecordingQualityEventTrigger;
            /** @enum {string} */
            monitoringDisposition?: AlarmMonitoringStateDisposition;
            failureReason?: string;
        };
        ContactId: {
            eventCode: number;
            zone: string;
        };
        Message: {
            subject?: string;
            body?: string;
        };
        VideoClipLink: {
            href?: string;
            method?: string;
            templated?: boolean;
        };
        VideoClipLinks: {
            "playback/dash": components["schemas"]["VideoClipLink"];
            "playback/flv": components["schemas"]["VideoClipLink"];
            "playback/hls": components["schemas"]["VideoClipLink"];
        };
        VideoClip: {
            id: number;
            recordingType: string;
            durationInSeconds: number;
            prerollInSeconds?: number;
            postrollInSeconds?: number;
            aspectRatio?: string;
            camera?: components["schemas"]["Camera"];
            links?: components["schemas"]["VideoClipLinks"];
        };
        Video: {
            startedBy?: string;
            clips: components["schemas"]["VideoClip"][];
        };
        SubscriptionEvent: {
            id: number;
            /** Format: date-time */
            timestamp: string;
            type: string;
            contactId: components["schemas"]["ContactId"];
            info: string;
            sensor?: components["schemas"]["Sensor"];
            message?: components["schemas"]["Message"];
            video?: components["schemas"]["Video"];
        };
        AlarmDetails: {
            id: string;
            locationId: string;
            /** Format: date-time */
            createdTimestamp: string;
            /** Format: date-time */
            updatedTimestamp: string;
            calculatorVersion?: string;
            /** @enum {string} */
            category: AlarmSummaryCategory;
            triggeringSignal: components["schemas"]["AlarmSignal"];
            governingAlarmSignalEventId?: string;
            governingSignal: components["schemas"]["AlarmSignal"];
            monitoring: components["schemas"]["AlarmMonitoringState"];
            customer: components["schemas"]["AlarmCustomerState"];
            dispatch: components["schemas"]["AlarmDispatchState"];
            /** @enum {string} */
            disposition?: AlarmSummaryDisposition;
            attributes?: components["schemas"]["Attributes"];
            timeline?: (components["schemas"]["TimelineAlarmSignalEvent"] | components["schemas"]["TimelineMonitoringServiceProviderAlarmSignalEvent"] | components["schemas"]["TimelineMonitoringServiceProviderAsapMessageEvent"] | components["schemas"]["TimelineMonitoringServiceProviderLocationIssueEvent"] | components["schemas"]["TimelineMonitoringSpecialistEvent"] | components["schemas"]["TimelineCameraRecordingQualityEvent"])[];
            triggeringSensor?: components["schemas"]["Sensor"];
            baseStationSerialNumber?: string;
            userId?: number;
            timezone?: number;
            locationOffset?: number;
            subscriptionEvents: components["schemas"]["SubscriptionEvent"][];
        };
        Token: {
            accessToken: string;
            lifespanInSeconds: number;
        };
        MonitoringServiceProviderLocation: {
            locationId: string;
        };
        Metric: {
            tableName: string;
            destinations: MetricDestinations[];
            metricName: string;
            metricType: string;
            value?: string | number;
            tags?: Record<string, unknown>;
        };
        EngagementCameraRecording: {
            /** @description Access allowed */
            accessAllowed: boolean;
            /** @description Recording URL */
            recordingUrl?: components["schemas"]["VideoClipLinks"];
            /**
             * Format: date-time
             * @description Start time of the clip
             */
            startTime?: string;
            /**
             * Format: date-time
             * @description End time of the clip
             */
            endTime?: string;
            /**
             * @description Disallowed reason
             * @enum {string}
             */
            disallowedReason?: EngagementCameraRecordingDisallowedReason;
        };
        SupportedFeatures: {
            monitoredLiveStream?: boolean;
            outdoorMonitoringEnabled: boolean;
            aspectRatio?: string;
        };
        PatchLocationCameraDevice: {
            isOutdoorMonitoringEnabled: boolean;
        };
        ServiceStatusSetting: {
            isEnabled: boolean;
            /** Format: date-time */
            startTimestamp?: string;
            /** Format: date-time */
            endTimestamp?: string;
        };
        LocationCameraDevice: {
            id: string;
            /** @enum {string} */
            category: LocationCameraDeviceCategory;
            isOutdoorMonitoringEnabled: boolean;
            noAction: components["schemas"]["ServiceStatusSetting"];
        };
        LocationSearchResponseDto: {
            locationId: string;
        };
        SuccessActionResult: {
            /** @enum {string} */
            type: SuccessActionResultType;
        };
        FailureActionResult: {
            /** @enum {string} */
            type: FailureActionResultType;
            errorMessage: string;
            errorCode?: string;
        };
        ClearLocationCommunicationAction: {
            id: string;
            /** @enum {string} */
            type: ClearLocationCommunicationActionType;
            /** @enum {string} */
            status: ClearLocationCommunicationActionStatus;
            result?: components["schemas"]["SuccessActionResult"] | components["schemas"]["FailureActionResult"];
            /** Format: date-time */
            createdAt: string;
            createdBy: string;
            /** Format: date-time */
            updatedAt: string;
            updatedBy: string;
            /** Format: date-time */
            startedAt?: string;
            /** Format: date-time */
            completedAt?: string;
            communicationName: string;
        };
        LocalizedString: {
            "en-US": string;
            "en-GB"?: string;
        };
        AppChannelContent: {
            heading: components["schemas"]["LocalizedString"];
            subHeading?: components["schemas"]["LocalizedString"];
            bodySummary: components["schemas"]["LocalizedString"];
            bodyMarkdown: components["schemas"]["LocalizedString"];
            actions: {
                [key: string]: unknown;
            };
        };
        EmailChannelContent: {
            subject?: components["schemas"]["LocalizedString"];
            body?: components["schemas"]["LocalizedString"];
            brazeCampaignName: string;
            brazeCampaignParameters: string[];
        };
        SmsChannelContent: {
            subject?: components["schemas"]["LocalizedString"];
            body: components["schemas"]["LocalizedString"];
        };
        PushChannelContent: {
            subject: components["schemas"]["LocalizedString"];
            body: components["schemas"]["LocalizedString"];
        };
        TimelineChannelContent: {
            title: components["schemas"]["LocalizedString"];
            body1?: components["schemas"]["LocalizedString"];
            body2?: components["schemas"]["LocalizedString"];
            iconName: string;
        };
        CommunicationChannels: {
            app?: components["schemas"]["AppChannelContent"];
            email?: components["schemas"]["EmailChannelContent"];
            sms?: components["schemas"]["SmsChannelContent"];
            push?: components["schemas"]["PushChannelContent"];
            timeline?: components["schemas"]["TimelineChannelContent"];
        };
        CustomerCommunicationAction: {
            id: string;
            /** @enum {string} */
            status: ClearLocationCommunicationActionStatus;
            result?: components["schemas"]["SuccessActionResult"] | components["schemas"]["FailureActionResult"];
            /** Format: date-time */
            createdAt: string;
            createdBy: string;
            /** Format: date-time */
            updatedAt: string;
            updatedBy: string;
            /** Format: date-time */
            startedAt?: string;
            /** Format: date-time */
            completedAt?: string;
            /** @enum {string} */
            type: CustomerCommunicationActionType;
            content: components["schemas"]["CommunicationChannels"];
            communicationName: string;
            communicationId?: string;
        };
        EscalationSuccessActionResult: {
            /** @enum {string} */
            type: SuccessActionResultType;
            ticketKey?: string;
        };
        CustomerEscalationAction: {
            id: string;
            /** @enum {string} */
            type: CustomerEscalationActionType;
            /** @enum {string} */
            status: ClearLocationCommunicationActionStatus;
            result?: components["schemas"]["EscalationSuccessActionResult"] | components["schemas"]["FailureActionResult"];
            /** Format: date-time */
            createdAt: string;
            createdBy: string;
            /** Format: date-time */
            updatedAt: string;
            updatedBy: string;
            /** Format: date-time */
            startedAt?: string;
            /** Format: date-time */
            completedAt?: string;
        };
        DuplicateClearanceReason: {
            /** @enum {string} */
            type: DuplicateClearanceReasonType;
            conflictingEngagementId: string;
        };
        CameraNotEnrolledReason: {
            /** @enum {string} */
            type: CameraNotEnrolledReasonType;
        };
        LocationNotSubscribedReason: {
            /** @enum {string} */
            type: LocationNotSubscribedReasonType;
        };
        AmbiguousCameraReason: {
            /** @enum {string} */
            type: AmbiguousCameraReasonType;
        };
        IgnoredAction: {
            id: string;
            /** @enum {string} */
            type: IgnoredActionType;
            /** @enum {string} */
            status: ClearLocationCommunicationActionStatus;
            result?: components["schemas"]["SuccessActionResult"] | components["schemas"]["FailureActionResult"];
            /** Format: date-time */
            createdAt: string;
            createdBy: string;
            /** Format: date-time */
            updatedAt: string;
            updatedBy: string;
            /** Format: date-time */
            startedAt?: string;
            /** Format: date-time */
            completedAt?: string;
            reason: components["schemas"]["DuplicateClearanceReason"] | components["schemas"]["CameraNotEnrolledReason"] | components["schemas"]["LocationNotSubscribedReason"] | components["schemas"]["AmbiguousCameraReason"];
        };
        UnenrollCameraAction: {
            id: string;
            /** @enum {string} */
            type: UnenrollCameraActionType;
            /** @enum {string} */
            status: ClearLocationCommunicationActionStatus;
            result?: components["schemas"]["SuccessActionResult"] | components["schemas"]["FailureActionResult"];
            /** Format: date-time */
            createdAt: string;
            createdBy: string;
            /** Format: date-time */
            updatedAt: string;
            updatedBy: string;
            /** Format: date-time */
            startedAt?: string;
            /** Format: date-time */
            completedAt?: string;
            cameraId: string;
        };
        Device: {
            id: string;
            serial?: string;
            /** @enum {string} */
            type: DeviceType;
            name: string;
        };
        DateInterval: {
            /** Format: date */
            start: string;
            /** Format: date */
            end?: string;
        };
        DeviceInfractionDetails: {
            /** @enum {string} */
            type: DeviceInfractionDetailsType;
            description?: string;
            device: components["schemas"]["Device"];
            /** @enum {string} */
            infractionType: DeviceInfractionDetailsInfractionType;
            applicableDates: components["schemas"]["DateInterval"][];
            links: string[];
        };
        AutomatedDeviceInfractionDetails: {
            /** @enum {string} */
            type: AutomatedDeviceInfractionDetailsType;
            description?: string;
            device: components["schemas"]["Device"];
            /** @enum {string} */
            infractionType: DeviceInfractionDetailsInfractionType;
            engagementId: string;
            documentedBy: string;
            /** @enum {string} */
            enforcementLevel?: AutomatedDeviceInfractionDetailsEnforcementLevel;
        };
        LocationCommunicationAction: {
            id: string;
            /** @enum {string} */
            type: LocationCommunicationActionType;
            /** @enum {string} */
            status: ClearLocationCommunicationActionStatus;
            result?: components["schemas"]["SuccessActionResult"] | components["schemas"]["FailureActionResult"];
            /** Format: date-time */
            createdAt: string;
            createdBy: string;
            /** Format: date-time */
            updatedAt: string;
            updatedBy: string;
            /** Format: date-time */
            startedAt?: string;
            /** Format: date-time */
            completedAt?: string;
            content: components["schemas"]["CommunicationChannels"];
            communicationName: string;
            communicationId?: string;
        };
        UserCommunicationAction: {
            id: string;
            /** @enum {string} */
            type: UserCommunicationActionType;
            /** @enum {string} */
            status: ClearLocationCommunicationActionStatus;
            result?: components["schemas"]["SuccessActionResult"] | components["schemas"]["FailureActionResult"];
            /** Format: date-time */
            createdAt: string;
            createdBy: string;
            /** Format: date-time */
            updatedAt: string;
            updatedBy: string;
            /** Format: date-time */
            startedAt?: string;
            /** Format: date-time */
            completedAt?: string;
            content: components["schemas"]["CommunicationChannels"];
            communicationName: string;
            communicationId?: string;
        };
        AddressGateCodeIssueModerationDetails: {
            /** @enum {string} */
            type: AddressGateCodeIssueModerationDetailsType;
            description?: string;
        };
        AddressMissingBusinessNameModerationDetails: {
            /** @enum {string} */
            type: AddressMissingBusinessNameModerationDetailsType;
            description?: string;
        };
        AddressUnableToLocateEntry: {
            /** @enum {string} */
            kind: AddressUnableToLocateEntryKind;
            /** Format: date-time */
            resolvedAt?: string;
        };
        AddressUnableToLocateModerationDetails: {
            /** @enum {string} */
            type: AddressUnableToLocateModerationDetailsType;
            description?: string;
            issues: components["schemas"]["AddressUnableToLocateEntry"][];
        };
        AddressValidationIssueEntry: {
            /** @enum {string} */
            kind: AddressValidationIssueEntryKind;
            /** Format: date-time */
            resolvedAt?: string;
        };
        AddressValidationIssueModerationDetails: {
            /** @enum {string} */
            type: AddressValidationIssueModerationDetailsType;
            description?: string;
            issues: components["schemas"]["AddressValidationIssueEntry"][];
        };
        AddressPoBoxIssueModerationDetails: {
            /** @enum {string} */
            type: AddressPoBoxIssueModerationDetailsType;
            description?: string;
        };
        AddressWrongAddressTypeIssueModerationDetails: {
            /** @enum {string} */
            type: AddressWrongAddressTypeIssueModerationDetailsType;
            description?: string;
        };
        PhoneContact: {
            name: string;
            phoneNumber: string;
        };
        PhoneBadNumberIssueEntry: {
            /** @enum {string} */
            kind: PhoneBadNumberIssueEntryKind;
            contact: components["schemas"]["PhoneContact"];
            /** Format: date-time */
            resolvedAt?: string;
        };
        PhoneBadNumberIssueModerationDetails: {
            /** @enum {string} */
            type: PhoneBadNumberIssueModerationDetailsType;
            description?: string;
            issues: components["schemas"]["PhoneBadNumberIssueEntry"][];
        };
        PhoneNoPrimaryContactsIssueModerationDetails: {
            /** @enum {string} */
            type: PhoneNoPrimaryContactsIssueModerationDetailsType;
            description?: string;
        };
        PhoneOnePrimaryContactIssueModerationDetails: {
            /** @enum {string} */
            type: PhoneOnePrimaryContactIssueModerationDetailsType;
            description?: string;
        };
        PhoneEmergencyNumberAsContactIssueModerationDetails: {
            /** @enum {string} */
            type: PhoneEmergencyNumberAsContactIssueModerationDetailsType;
            description?: string;
        };
        PsaSafewordReminderDetails: {
            /** @enum {string} */
            type: PsaSafewordReminderDetailsType;
            description?: string;
        };
        PsaReviewNotificationSettingsDetails: {
            /** @enum {string} */
            type: PsaReviewNotificationSettingsDetailsType;
            description?: string;
        };
        ModerationEvent: {
            id: string;
            locationId: string;
            /** @enum {string} */
            source: ModerationEventSource;
            /** @enum {string} */
            status: ModerationEventStatus;
            /** Format: date-time */
            createdAt: string;
            createdBy: string;
            /** Format: date-time */
            updatedAt: string;
            updatedBy: string;
            actions: (components["schemas"]["ClearLocationCommunicationAction"] | components["schemas"]["CustomerCommunicationAction"] | components["schemas"]["CustomerEscalationAction"] | components["schemas"]["IgnoredAction"] | components["schemas"]["UnenrollCameraAction"])[];
            details: components["schemas"]["DeviceInfractionDetails"] | components["schemas"]["AutomatedDeviceInfractionDetails"];
        };
        CustomerCommunicationActionRequest: {
            /** @enum {string} */
            type: CustomerCommunicationActionType;
        };
        CustomerEscalationActionRequest: {
            /** @enum {string} */
            type: CustomerEscalationActionType;
        };
        UnenrollCameraActionRequest: {
            /** @enum {string} */
            type: UnenrollCameraActionType;
            cameraId: string;
        };
        ModerationEventSource: {
            details: components["schemas"]["DeviceInfractionDetails"] | components["schemas"]["AutomatedDeviceInfractionDetails"] | components["schemas"]["AddressGateCodeIssueModerationDetails"] | components["schemas"]["AddressMissingBusinessNameModerationDetails"] | components["schemas"]["AddressUnableToLocateModerationDetails"] | components["schemas"]["AddressValidationIssueModerationDetails"] | components["schemas"]["AddressPoBoxIssueModerationDetails"] | components["schemas"]["AddressWrongAddressTypeIssueModerationDetails"] | components["schemas"]["PhoneBadNumberIssueModerationDetails"] | components["schemas"]["PhoneNoPrimaryContactsIssueModerationDetails"] | components["schemas"]["PhoneOnePrimaryContactIssueModerationDetails"] | components["schemas"]["PhoneEmergencyNumberAsContactIssueModerationDetails"] | components["schemas"]["PsaSafewordReminderDetails"] | components["schemas"]["PsaReviewNotificationSettingsDetails"];
            requestedActions: (components["schemas"]["CustomerCommunicationActionRequest"] | components["schemas"]["CustomerEscalationActionRequest"] | components["schemas"]["UnenrollCameraActionRequest"])[];
        };
        UpdateModerationEvent: {
            /** @enum {string} */
            status: UpdateModerationEventStatus;
        };
        EngagementHandler: {
            id: string;
        };
        MonitoringSpecialistActor: {
            /** @enum {string} */
            monitoringServiceProviderId: MonitoringSpecialistActorMonitoringServiceProviderId;
            id: string;
        };
        MonitoringSpecialistAssignment: {
            monitoringSpecialist: components["schemas"]["MonitoringSpecialistActor"];
            /** Format: date-time */
            timestamp: string;
        };
        EngagementQueue: {
            name: string;
        };
        SystemState: {
            /** @enum {string} */
            state: SystemStateState;
            /** Format: date-time */
            stateTimestamp: string;
        };
        BoundingBox: {
            x: number;
            y: number;
            w: number;
            h: number;
        };
        MotionDetection: {
            id: string;
            ptsSeconds: number;
            /** @enum {string} */
            type: MotionDetectionType;
            boundingBox?: components["schemas"]["BoundingBox"];
        };
        PersonDetection: {
            id: string;
            ptsSeconds: number;
            /** @enum {string} */
            type: PersonDetectionType;
            boundingBox?: components["schemas"]["BoundingBox"];
        };
        FaceDetection: {
            id: string;
            ptsSeconds: number;
            /** @enum {string} */
            type: FaceDetectionType;
            boundingBox?: components["schemas"]["BoundingBox"];
            matchPersonId?: string;
        };
        Analysis: {
            /** @enum {string} */
            state: AnalysisState;
            detections?: (components["schemas"]["MotionDetection"] | components["schemas"]["PersonDetection"] | components["schemas"]["FaceDetection"])[];
        };
        VideoRecording: {
            id: string;
            cameraId: string;
            /** Format: date-time */
            timestamp: string;
            /** @enum {string} */
            type: VideoRecordingType;
            analysis?: components["schemas"]["Analysis"];
        };
        ComputerVisionDetectionRelevantImage: {
            id: string;
            /** @enum {string} */
            type: ComputerVisionDetectionRelevantImageType;
        };
        FamiliarFaceTwoWayAudioParticipant: {
            /** @enum {string} */
            type: FamiliarFaceTwoWayAudioParticipantType;
            id: string;
            /** @enum {string} */
            matchQuality: FamiliarFaceTwoWayAudioParticipantMatchQuality;
        };
        UnfamiliarFaceTwoWayAudioParticipant: {
            /** @enum {string} */
            type: UnfamiliarFaceTwoWayAudioParticipantType;
            name: string;
        };
        CompleteTwoWayAudioInteractionOutdoorActivityResult: {
            /** @enum {string} */
            type: CompleteTwoWayAudioInteractionOutdoorActivityResultType;
            participants: (components["schemas"]["FamiliarFaceTwoWayAudioParticipant"] | components["schemas"]["UnfamiliarFaceTwoWayAudioParticipant"])[];
            statedPurpose?: string;
            flaggedIssues: string[];
            /** @enum {string} */
            audioQuality: CompleteTwoWayAudioInteractionOutdoorActivityResultAudioQuality;
        };
        IncompleteTwoWayAudioInteractionOutdoorActivityResult: {
            /** @enum {string} */
            type: IncompleteTwoWayAudioInteractionOutdoorActivityResultType;
            participants: (components["schemas"]["FamiliarFaceTwoWayAudioParticipant"] | components["schemas"]["UnfamiliarFaceTwoWayAudioParticipant"])[];
            statedPurpose?: string;
            flaggedIssues: string[];
            /** @enum {string} */
            audioQuality: CompleteTwoWayAudioInteractionOutdoorActivityResultAudioQuality;
            /** @enum {string} */
            reason: IncompleteTwoWayAudioInteractionOutdoorActivityResultReason;
        };
        NoTwoWayAudioInteractionOutdoorActivityResult: {
            /** @enum {string} */
            type: NoTwoWayAudioInteractionOutdoorActivityResultType;
            participants: (components["schemas"]["FamiliarFaceTwoWayAudioParticipant"] | components["schemas"]["UnfamiliarFaceTwoWayAudioParticipant"])[];
            statedPurpose?: string;
            flaggedIssues: string[];
            /** @enum {string} */
            audioQuality: CompleteTwoWayAudioInteractionOutdoorActivityResultAudioQuality;
            /** @enum {string} */
            reason: NoTwoWayAudioInteractionOutdoorActivityResultReason;
        };
        OutdoorEngagementResolution: {
            /** @enum {string} */
            category: OutdoorEngagementResolutionCategory;
            /** Format: date-time */
            timestamp: string;
        };
        SystemActor: {
            /** @enum {string} */
            type: SystemActorType;
        };
        ComputerVisionActor: {
            /** @enum {string} */
            type: ComputerVisionActorType;
        };
        OutdoorEngagementClearance: {
            actor: components["schemas"]["SystemActor"] | components["schemas"]["ComputerVisionActor"] | components["schemas"]["MonitoringSpecialistActor"];
            /** Format: date-time */
            timestamp: string;
            /** @enum {string} */
            engagementBlock?: OutdoorEngagementClearanceEngagementBlock;
        };
        OutdoorEngagementEscalation: {
            escalationNote: string;
            cameraId: string;
            /** @enum {string} */
            numberOfPeopleObserved: OutdoorEngagementEscalationNumberOfPeopleObserved;
        };
        SupersedingEngagement: {
            engagementId: string;
            /** @enum {string} */
            engagementType?: SupersedingEngagementEngagementType;
            /** Format: date-time */
            accessedTimestamp?: string;
        };
        MatchedFamiliarFace: {
            personId: string;
            matchedBy: (components["schemas"]["SystemActor"] | components["schemas"]["ComputerVisionActor"] | components["schemas"]["MonitoringSpecialistActor"])[];
        };
        OutdoorEngagementResult: {
            resolution: components["schemas"]["OutdoorEngagementResolution"];
            clearance?: components["schemas"]["OutdoorEngagementClearance"];
            escalation?: components["schemas"]["OutdoorEngagementEscalation"];
            internalNote?: string;
            relevantImages?: components["schemas"]["ComputerVisionDetectionRelevantImage"][];
            supersedingEngagement?: components["schemas"]["SupersedingEngagement"];
            twoWayAudioInteraction?: components["schemas"]["CompleteTwoWayAudioInteractionOutdoorActivityResult"] | components["schemas"]["IncompleteTwoWayAudioInteractionOutdoorActivityResult"] | components["schemas"]["NoTwoWayAudioInteractionOutdoorActivityResult"];
            matchedFamiliarFaces?: components["schemas"]["MatchedFamiliarFace"][];
        };
        EngagementConfiguration: {
            isTwoWayAudioEscalationOnly: boolean;
        };
        OutdoorEngagement: {
            id: string;
            /** @enum {string} */
            type: SupersedingEngagementEngagementType;
            incidentId: string;
            locationId: string;
            handler: components["schemas"]["EngagementHandler"];
            /** Format: date-time */
            createdTimestamp: string;
            /** Format: date-time */
            updatedTimestamp: string;
            monitoringSpecialistAssignment?: components["schemas"]["MonitoringSpecialistAssignment"];
            engagementQueue?: components["schemas"]["EngagementQueue"];
            triggeringDevice: components["schemas"]["Device"];
            triggeredSystemState?: components["schemas"]["SystemState"];
            videoRecordings: components["schemas"]["VideoRecording"][];
            result?: components["schemas"]["OutdoorEngagementResult"];
            configuration?: components["schemas"]["EngagementConfiguration"];
        };
        ActivityCreation: {
            /** Format: date-time */
            timestamp: string;
            actor: components["schemas"]["SystemActor"] | components["schemas"]["ComputerVisionActor"] | components["schemas"]["MonitoringSpecialistActor"];
        };
        ActivityAssignment: {
            /** Format: date-time */
            timestamp: string;
            assignedTo: components["schemas"]["SystemActor"] | components["schemas"]["ComputerVisionActor"] | components["schemas"]["MonitoringSpecialistActor"];
            assignedBy: components["schemas"]["SystemActor"] | components["schemas"]["ComputerVisionActor"] | components["schemas"]["MonitoringSpecialistActor"];
        };
        ActivityInitiation: {
            /** Format: date-time */
            timestamp: string;
            actor?: components["schemas"]["MonitoringSpecialistActor"];
        };
        EngagementAssignedOutdoorActivityResult: {
            /** @enum {string} */
            type: EngagementAssignedOutdoorActivityResultType;
            monitoringSpecialistActor: components["schemas"]["MonitoringSpecialistActor"];
        };
        EngagementObsoletedOutdoorActivityResult: {
            /** @enum {string} */
            type: EngagementObsoletedOutdoorActivityResultType;
        };
        EngagementResolvedOutdoorActivityResult: {
            /** @enum {string} */
            type: EngagementResolvedOutdoorActivityResultType;
        };
        SupersededOutdoorActivityResult: {
            /** @enum {string} */
            type: SupersededOutdoorActivityResultType;
            /** @enum {string} */
            activityType: SupersededOutdoorActivityResultActivityType;
        };
        AbandonedOutdoorActivityResult: {
            /** @enum {string} */
            type: AbandonedOutdoorActivityResultType;
            /** @enum {string} */
            reason?: AbandonedOutdoorActivityResultReason;
        };
        MonitoringSpecialistAssignmentOutdoorActivityCompletion: {
            /** Format: date-time */
            timestamp: string;
            actor: components["schemas"]["SystemActor"] | components["schemas"]["ComputerVisionActor"] | components["schemas"]["MonitoringSpecialistActor"];
            result: components["schemas"]["EngagementAssignedOutdoorActivityResult"] | components["schemas"]["EngagementObsoletedOutdoorActivityResult"] | components["schemas"]["EngagementResolvedOutdoorActivityResult"] | components["schemas"]["SupersededOutdoorActivityResult"] | components["schemas"]["AbandonedOutdoorActivityResult"];
        };
        MonitoringSpecialistAssignmentOutdoorActivity: {
            id: string;
            /** @enum {string} */
            type: MonitoringSpecialistAssignmentOutdoorActivityType;
            /** @enum {string} */
            engagementType: SupersedingEngagementEngagementType;
            engagementId: string;
            created: components["schemas"]["ActivityCreation"];
            assigned?: components["schemas"]["ActivityAssignment"];
            started?: components["schemas"]["ActivityInitiation"];
            completed?: components["schemas"]["MonitoringSpecialistAssignmentOutdoorActivityCompletion"];
        };
        BouncedOutdoorActivityResult: {
            /** @enum {string} */
            type: BouncedOutdoorActivityResultType;
        };
        DroppedOutdoorActivityResult: {
            /** @enum {string} */
            type: DroppedOutdoorActivityResultType;
        };
        NoVideoAvailableOutdoorActivityResult: {
            /** @enum {string} */
            type: NoVideoAvailableOutdoorActivityResultType;
        };
        EngagementPromotedToInvestigateOutdoorActivityResult: {
            /** @enum {string} */
            type: EngagementPromotedToInvestigateOutdoorActivityResultType;
        };
        EngagementQuickClearedOutdoorActivityResult: {
            /** @enum {string} */
            type: EngagementQuickClearedOutdoorActivityResultType;
            /** @enum {string} */
            category: OutdoorEngagementResolutionCategory;
        };
        MonitoringSpecialistTriageOutdoorActivityCompletion: {
            /** Format: date-time */
            timestamp: string;
            actor: components["schemas"]["SystemActor"] | components["schemas"]["ComputerVisionActor"] | components["schemas"]["MonitoringSpecialistActor"];
            result: components["schemas"]["BouncedOutdoorActivityResult"] | components["schemas"]["DroppedOutdoorActivityResult"] | components["schemas"]["AbandonedOutdoorActivityResult"] | components["schemas"]["NoVideoAvailableOutdoorActivityResult"] | components["schemas"]["EngagementPromotedToInvestigateOutdoorActivityResult"] | components["schemas"]["EngagementResolvedOutdoorActivityResult"] | components["schemas"]["EngagementQuickClearedOutdoorActivityResult"];
        };
        MonitoringSpecialistTriageOutdoorActivity: {
            id: string;
            /** @enum {string} */
            type: MonitoringSpecialistTriageOutdoorActivityType;
            /** @enum {string} */
            engagementType: SupersedingEngagementEngagementType;
            engagementId: string;
            created: components["schemas"]["ActivityCreation"];
            assigned?: components["schemas"]["ActivityAssignment"];
            started?: components["schemas"]["ActivityInitiation"];
            completed?: components["schemas"]["MonitoringSpecialistTriageOutdoorActivityCompletion"];
        };
        CooldownTimerCompletedOutdoorActivityResult: {
            /** @enum {string} */
            type: CooldownTimerCompletedOutdoorActivityResultType;
        };
        CooldownManuallyClearedOutdoorActivityResult: {
            /** @enum {string} */
            type: CooldownManuallyClearedOutdoorActivityResultType;
        };
        AutoClearCooldownFromFeedOutdoorActivityCompletion: {
            /** Format: date-time */
            timestamp: string;
            actor: components["schemas"]["SystemActor"] | components["schemas"]["ComputerVisionActor"] | components["schemas"]["MonitoringSpecialistActor"];
            result: components["schemas"]["CooldownTimerCompletedOutdoorActivityResult"] | components["schemas"]["CooldownManuallyClearedOutdoorActivityResult"] | components["schemas"]["AbandonedOutdoorActivityResult"];
        };
        AutoClearCooldownFromFeedOutdoorActivity: {
            id: string;
            /** @enum {string} */
            type: AutoClearCooldownFromFeedOutdoorActivityType;
            /** @enum {string} */
            engagementType: SupersedingEngagementEngagementType;
            engagementId: string;
            created: components["schemas"]["ActivityCreation"];
            assigned?: components["schemas"]["ActivityAssignment"];
            started?: components["schemas"]["ActivityInitiation"];
            completed?: components["schemas"]["AutoClearCooldownFromFeedOutdoorActivityCompletion"];
        };
        AutoClearCooldownFromInvestigateOutdoorActivityCompletion: {
            /** Format: date-time */
            timestamp: string;
            actor: components["schemas"]["SystemActor"] | components["schemas"]["ComputerVisionActor"] | components["schemas"]["MonitoringSpecialistActor"];
            result: components["schemas"]["CooldownTimerCompletedOutdoorActivityResult"] | components["schemas"]["CooldownManuallyClearedOutdoorActivityResult"] | components["schemas"]["AbandonedOutdoorActivityResult"];
        };
        AutoClearCooldownFromInvestigateOutdoorActivity: {
            id: string;
            /** @enum {string} */
            type: AutoClearCooldownFromInvestigateOutdoorActivityType;
            /** @enum {string} */
            engagementType: SupersedingEngagementEngagementType;
            engagementId: string;
            created: components["schemas"]["ActivityCreation"];
            assigned?: components["schemas"]["ActivityAssignment"];
            started?: components["schemas"]["ActivityInitiation"];
            completed?: components["schemas"]["AutoClearCooldownFromInvestigateOutdoorActivityCompletion"];
        };
        QuickClearFromInvestigateOutdoorActivityCompletion: {
            /** Format: date-time */
            timestamp: string;
            actor: components["schemas"]["SystemActor"] | components["schemas"]["ComputerVisionActor"] | components["schemas"]["MonitoringSpecialistActor"];
            result: components["schemas"]["EngagementQuickClearedOutdoorActivityResult"] | components["schemas"]["SupersededOutdoorActivityResult"] | components["schemas"]["AbandonedOutdoorActivityResult"] | components["schemas"]["EngagementResolvedOutdoorActivityResult"] | components["schemas"]["NoVideoAvailableOutdoorActivityResult"];
        };
        QuickClearFromInvestigateOutdoorActivity: {
            id: string;
            /** @enum {string} */
            type: QuickClearFromInvestigateOutdoorActivityType;
            /** @enum {string} */
            engagementType: SupersedingEngagementEngagementType;
            engagementId: string;
            created: components["schemas"]["ActivityCreation"];
            assigned?: components["schemas"]["ActivityAssignment"];
            started?: components["schemas"]["ActivityInitiation"];
            completed?: components["schemas"]["QuickClearFromInvestigateOutdoorActivityCompletion"];
        };
        EscalationDetails: {
            description: string;
            /** @enum {string} */
            category: OutdoorEngagementResolutionCategory;
        };
        EngagementEscalatedWithDescriptionOutdoorActivityResult: {
            /** @enum {string} */
            type: EngagementEscalatedWithDescriptionOutdoorActivityResultType;
            /** @enum {string} */
            category: OutdoorEngagementResolutionCategory;
            escalationDetails: components["schemas"]["EscalationDetails"];
        };
        EscalateToIntrusionWithDescriptionOutdoorActivityCompletion: {
            /** Format: date-time */
            timestamp: string;
            actor: components["schemas"]["SystemActor"] | components["schemas"]["ComputerVisionActor"] | components["schemas"]["MonitoringSpecialistActor"];
            result: components["schemas"]["EngagementEscalatedWithDescriptionOutdoorActivityResult"] | components["schemas"]["SupersededOutdoorActivityResult"] | components["schemas"]["AbandonedOutdoorActivityResult"] | components["schemas"]["EngagementResolvedOutdoorActivityResult"];
        };
        EscalateToIntrusionWithDescriptionOutdoorActivity: {
            id: string;
            /** @enum {string} */
            type: EscalateToIntrusionWithDescriptionOutdoorActivityType;
            /** @enum {string} */
            engagementType: SupersedingEngagementEngagementType;
            engagementId: string;
            created: components["schemas"]["ActivityCreation"];
            assigned?: components["schemas"]["ActivityAssignment"];
            started?: components["schemas"]["ActivityInitiation"];
            completed?: components["schemas"]["EscalateToIntrusionWithDescriptionOutdoorActivityCompletion"];
        };
        NewIncidentOutdoorActivityResult: {
            /** @enum {string} */
            type: NewIncidentOutdoorActivityResultType;
        };
        EngagementLinkedWithoutAdditionalHandlingOutdoorActivityResult: {
            /** @enum {string} */
            type: EngagementLinkedWithoutAdditionalHandlingOutdoorActivityResultType;
            incidentId: string;
        };
        EngagementLinkedWithAdditionalHandlingOutdoorActivityResult: {
            /** @enum {string} */
            type: EngagementLinkedWithAdditionalHandlingOutdoorActivityResultType;
            incidentId: string;
        };
        RecentHistoryOutdoorActivityCompletion: {
            /** Format: date-time */
            timestamp: string;
            actor: components["schemas"]["SystemActor"] | components["schemas"]["ComputerVisionActor"] | components["schemas"]["MonitoringSpecialistActor"];
            result: components["schemas"]["NewIncidentOutdoorActivityResult"] | components["schemas"]["EngagementLinkedWithoutAdditionalHandlingOutdoorActivityResult"] | components["schemas"]["EngagementLinkedWithAdditionalHandlingOutdoorActivityResult"] | components["schemas"]["SupersededOutdoorActivityResult"] | components["schemas"]["AbandonedOutdoorActivityResult"] | components["schemas"]["EngagementResolvedOutdoorActivityResult"];
        };
        RecentOutdoorMonitoringEngagement: {
            id: string;
            /** Format: date-time */
            createdTimestamp: string;
            result?: components["schemas"]["OutdoorEngagementResult"];
            twoWayAudioInteractionResult?: components["schemas"]["CompleteTwoWayAudioInteractionOutdoorActivityResult"] | components["schemas"]["IncompleteTwoWayAudioInteractionOutdoorActivityResult"] | components["schemas"]["NoTwoWayAudioInteractionOutdoorActivityResult"];
            matchedFamiliarFaces?: components["schemas"]["MatchedFamiliarFace"][];
        };
        RecentOutdoorMonitoringIncident: {
            id: string;
            /** @enum {string} */
            linkability: RecentOutdoorMonitoringIncidentLinkability;
            engagements: components["schemas"]["RecentOutdoorMonitoringEngagement"][];
        };
        RecentHistoryOutdoorActivity: {
            id: string;
            /** @enum {string} */
            type: RecentHistoryOutdoorActivityType;
            /** @enum {string} */
            engagementType: SupersedingEngagementEngagementType;
            engagementId: string;
            created: components["schemas"]["ActivityCreation"];
            assigned?: components["schemas"]["ActivityAssignment"];
            started?: components["schemas"]["ActivityInitiation"];
            completed?: components["schemas"]["RecentHistoryOutdoorActivityCompletion"];
            incidents: components["schemas"]["RecentOutdoorMonitoringIncident"][];
        };
        TwoWayAudioCheckpointOptionSelectedOutdoorActivityResult: {
            /** @enum {string} */
            type: TwoWayAudioCheckpointOptionSelectedOutdoorActivityResultType;
            /** @enum {string} */
            selection: TwoWayAudioCheckpointOptionSelectedOutdoorActivityResultSelection;
        };
        TwoWayAudioCheckpointOutdoorActivityCompletion: {
            /** Format: date-time */
            timestamp: string;
            actor: components["schemas"]["SystemActor"] | components["schemas"]["ComputerVisionActor"] | components["schemas"]["MonitoringSpecialistActor"];
            result: components["schemas"]["TwoWayAudioCheckpointOptionSelectedOutdoorActivityResult"] | components["schemas"]["SupersededOutdoorActivityResult"] | components["schemas"]["AbandonedOutdoorActivityResult"] | components["schemas"]["EngagementResolvedOutdoorActivityResult"];
        };
        TwoWayAudioCheckpointOutdoorActivity: {
            id: string;
            /** @enum {string} */
            type: TwoWayAudioCheckpointOutdoorActivityType;
            /** @enum {string} */
            engagementType: SupersedingEngagementEngagementType;
            engagementId: string;
            created: components["schemas"]["ActivityCreation"];
            assigned?: components["schemas"]["ActivityAssignment"];
            started?: components["schemas"]["ActivityInitiation"];
            completed?: components["schemas"]["TwoWayAudioCheckpointOutdoorActivityCompletion"];
        };
        FamiliarFaceMatch: {
            faceId: string;
            isMatch: boolean;
        };
        FamiliarFacesIdentifiedOutdoorActivityResult: {
            /** @enum {string} */
            type: FamiliarFacesIdentifiedOutdoorActivityResultType;
            familiarFaces: components["schemas"]["FamiliarFaceMatch"][];
        };
        NoFamiliarFacesIdentifiedOutdoorActivityResult: {
            /** @enum {string} */
            type: NoFamiliarFacesIdentifiedOutdoorActivityResultType;
            familiarFaces: components["schemas"]["FamiliarFaceMatch"][];
        };
        FamiliarFaceReviewWithoutAIOutdoorActivityCompletion: {
            /** Format: date-time */
            timestamp: string;
            actor: components["schemas"]["SystemActor"] | components["schemas"]["ComputerVisionActor"] | components["schemas"]["MonitoringSpecialistActor"];
            result: components["schemas"]["FamiliarFacesIdentifiedOutdoorActivityResult"] | components["schemas"]["NoFamiliarFacesIdentifiedOutdoorActivityResult"] | components["schemas"]["SupersededOutdoorActivityResult"] | components["schemas"]["AbandonedOutdoorActivityResult"] | components["schemas"]["EngagementResolvedOutdoorActivityResult"];
        };
        FamiliarFace: {
            id: string;
            /** @enum {string} */
            category: FamiliarFaceTwoWayAudioParticipantType;
        };
        FamiliarFaceReviewWithoutAIOutdoorActivity: {
            id: string;
            /** @enum {string} */
            type: FamiliarFaceReviewWithoutAIOutdoorActivityType;
            /** @enum {string} */
            engagementType: SupersedingEngagementEngagementType;
            engagementId: string;
            created: components["schemas"]["ActivityCreation"];
            assigned?: components["schemas"]["ActivityAssignment"];
            started?: components["schemas"]["ActivityInitiation"];
            completed?: components["schemas"]["FamiliarFaceReviewWithoutAIOutdoorActivityCompletion"];
            familiarFaces?: components["schemas"]["FamiliarFace"][];
        };
        BaseTwoWayAudioInteractionOutdoorActivityResult: {
            /** @enum {string} */
            type: BaseTwoWayAudioInteractionOutdoorActivityResultType;
            participants: (components["schemas"]["FamiliarFaceTwoWayAudioParticipant"] | components["schemas"]["UnfamiliarFaceTwoWayAudioParticipant"])[];
            statedPurpose?: string;
            flaggedIssues: string[];
            /** @enum {string} */
            audioQuality: CompleteTwoWayAudioInteractionOutdoorActivityResultAudioQuality;
        };
        TwoWayAudioInteractionOutdoorActivityCompletion: {
            /** Format: date-time */
            timestamp: string;
            actor: components["schemas"]["SystemActor"] | components["schemas"]["ComputerVisionActor"] | components["schemas"]["MonitoringSpecialistActor"];
            result: components["schemas"]["BaseTwoWayAudioInteractionOutdoorActivityResult"] & (components["schemas"]["CompleteTwoWayAudioInteractionOutdoorActivityResult"] | components["schemas"]["IncompleteTwoWayAudioInteractionOutdoorActivityResult"] | components["schemas"]["NoTwoWayAudioInteractionOutdoorActivityResult"] | components["schemas"]["SupersededOutdoorActivityResult"] | components["schemas"]["AbandonedOutdoorActivityResult"] | components["schemas"]["EngagementResolvedOutdoorActivityResult"]);
        };
        TwoWayAudioInteractionOutdoorActivity: {
            id: string;
            /** @enum {string} */
            type: TwoWayAudioInteractionOutdoorActivityType;
            /** @enum {string} */
            engagementType: SupersedingEngagementEngagementType;
            engagementId: string;
            created: components["schemas"]["ActivityCreation"];
            assigned?: components["schemas"]["ActivityAssignment"];
            started?: components["schemas"]["ActivityInitiation"];
            completed?: components["schemas"]["TwoWayAudioInteractionOutdoorActivityCompletion"];
        };
        InternalNote: {
            wasRequired: boolean;
            value?: string;
        };
        PeopleObserved: {
            /** @enum {string} */
            numberOfPeopleObserved: OutdoorEngagementEscalationNumberOfPeopleObserved;
            /** @enum {string} */
            remainedInCameraView: PeopleObservedRemainedInCameraView;
        };
        RelevantImageSelection: {
            image: components["schemas"]["ComputerVisionDetectionRelevantImage"];
            wasSelected: boolean;
        };
        EngagementFinalizedOutdoorActivityResult: {
            /** @enum {string} */
            type: EngagementFinalizedOutdoorActivityResultType;
            internalNote: components["schemas"]["InternalNote"];
            peopleObserved?: components["schemas"]["PeopleObserved"];
            relevantImages?: components["schemas"]["RelevantImageSelection"][];
        };
        FinalDocumentationOutdoorActivityCompletion: {
            /** Format: date-time */
            timestamp: string;
            actor: components["schemas"]["SystemActor"] | components["schemas"]["ComputerVisionActor"] | components["schemas"]["MonitoringSpecialistActor"];
            result: components["schemas"]["EngagementFinalizedOutdoorActivityResult"] | components["schemas"]["SupersededOutdoorActivityResult"] | components["schemas"]["AbandonedOutdoorActivityResult"] | components["schemas"]["EngagementResolvedOutdoorActivityResult"];
        };
        FinalDocumentationOutdoorActivity: {
            id: string;
            /** @enum {string} */
            type: FinalDocumentationOutdoorActivityType;
            /** @enum {string} */
            engagementType: SupersedingEngagementEngagementType;
            engagementId: string;
            created: components["schemas"]["ActivityCreation"];
            assigned?: components["schemas"]["ActivityAssignment"];
            started?: components["schemas"]["ActivityInitiation"];
            completed?: components["schemas"]["FinalDocumentationOutdoorActivityCompletion"];
            /** @enum {string} */
            category: OutdoorEngagementResolutionCategory;
        };
        PagedEngagements: {
            items: components["schemas"]["OutdoorEngagement"][];
            nextToken?: string;
        };
        OutdoorActivityCreatedEvent: {
            id: string;
            /** Format: date-time */
            timestamp: string;
            /** @enum {string} */
            type: OutdoorActivityCreatedEventType;
            engagementId: string;
            locationId: string;
            blockId?: string;
            actionId?: string;
            activityId: string;
            activity: components["schemas"]["MonitoringSpecialistAssignmentOutdoorActivity"] | components["schemas"]["MonitoringSpecialistTriageOutdoorActivity"] | components["schemas"]["AutoClearCooldownFromFeedOutdoorActivity"] | components["schemas"]["AutoClearCooldownFromInvestigateOutdoorActivity"] | components["schemas"]["QuickClearFromInvestigateOutdoorActivity"] | components["schemas"]["EscalateToIntrusionWithDescriptionOutdoorActivity"] | components["schemas"]["RecentHistoryOutdoorActivity"] | components["schemas"]["TwoWayAudioCheckpointOutdoorActivity"] | components["schemas"]["FamiliarFaceReviewWithoutAIOutdoorActivity"] | components["schemas"]["TwoWayAudioInteractionOutdoorActivity"] | components["schemas"]["FinalDocumentationOutdoorActivity"];
            actor: components["schemas"]["SystemActor"] | components["schemas"]["ComputerVisionActor"] | components["schemas"]["MonitoringSpecialistActor"];
        };
        OutdoorActivityAssignedEvent: {
            id: string;
            /** Format: date-time */
            timestamp: string;
            /** @enum {string} */
            type: OutdoorActivityAssignedEventType;
            engagementId: string;
            locationId: string;
            blockId?: string;
            actionId?: string;
            activityId: string;
            assignedTo: components["schemas"]["SystemActor"] | components["schemas"]["ComputerVisionActor"] | components["schemas"]["MonitoringSpecialistActor"];
            assignedBy: components["schemas"]["SystemActor"] | components["schemas"]["ComputerVisionActor"] | components["schemas"]["MonitoringSpecialistActor"];
        };
        OutdoorActivityStartedEvent: {
            id: string;
            /** Format: date-time */
            timestamp: string;
            /** @enum {string} */
            type: OutdoorActivityStartedEventType;
            engagementId: string;
            locationId: string;
            blockId?: string;
            actionId?: string;
            activityId: string;
        };
        OutdoorActivityCompletedEvent: {
            id: string;
            /** Format: date-time */
            timestamp: string;
            /** @enum {string} */
            type: OutdoorActivityCompletedEventType;
            engagementId: string;
            locationId: string;
            blockId?: string;
            actionId?: string;
            activityId: string;
            actor: components["schemas"]["SystemActor"] | components["schemas"]["ComputerVisionActor"] | components["schemas"]["MonitoringSpecialistActor"];
            result: components["schemas"]["EngagementAssignedOutdoorActivityResult"] | components["schemas"]["EngagementResolvedOutdoorActivityResult"] | components["schemas"]["BouncedOutdoorActivityResult"] | components["schemas"]["DroppedOutdoorActivityResult"] | components["schemas"]["AbandonedOutdoorActivityResult"] | components["schemas"]["SupersededOutdoorActivityResult"] | components["schemas"]["EngagementObsoletedOutdoorActivityResult"] | components["schemas"]["NoVideoAvailableOutdoorActivityResult"] | components["schemas"]["EngagementQuickClearedOutdoorActivityResult"] | components["schemas"]["EngagementPromotedToInvestigateOutdoorActivityResult"] | components["schemas"]["CooldownTimerCompletedOutdoorActivityResult"] | components["schemas"]["CooldownManuallyClearedOutdoorActivityResult"] | components["schemas"]["EngagementEscalatedWithDescriptionOutdoorActivityResult"] | components["schemas"]["EngagementFinalizedOutdoorActivityResult"] | components["schemas"]["NewIncidentOutdoorActivityResult"] | components["schemas"]["EngagementLinkedWithoutAdditionalHandlingOutdoorActivityResult"] | components["schemas"]["EngagementLinkedWithAdditionalHandlingOutdoorActivityResult"] | components["schemas"]["TwoWayAudioCheckpointOptionSelectedOutdoorActivityResult"] | components["schemas"]["FamiliarFacesIdentifiedOutdoorActivityResult"] | components["schemas"]["NoFamiliarFacesIdentifiedOutdoorActivityResult"] | components["schemas"]["CompleteTwoWayAudioInteractionOutdoorActivityResult"] | components["schemas"]["IncompleteTwoWayAudioInteractionOutdoorActivityResult"] | components["schemas"]["NoTwoWayAudioInteractionOutdoorActivityResult"];
        };
        OutdoorEngagementCreatedEvent: {
            id: string;
            /** Format: date-time */
            timestamp: string;
            /** @enum {string} */
            type: OutdoorEngagementCreatedEventType;
            engagementId: string;
            locationId: string;
            blockId?: string;
            actionId?: string;
            /** @enum {string} */
            engagementType: SupersedingEngagementEngagementType;
            incidentId: string;
        };
        OutdoorEngagementAssignedEvent: {
            id: string;
            /** Format: date-time */
            timestamp: string;
            /** @enum {string} */
            type: OutdoorEngagementAssignedEventType;
            engagementId: string;
            locationId: string;
            blockId?: string;
            actionId?: string;
            /** @enum {string} */
            engagementType: SupersedingEngagementEngagementType;
            monitoringSpecialist: components["schemas"]["MonitoringSpecialistActor"];
        };
        OutdoorEngagementResolvedEvent: {
            id: string;
            /** Format: date-time */
            timestamp: string;
            /** @enum {string} */
            type: OutdoorEngagementResolvedEventType;
            engagementId: string;
            locationId: string;
            blockId?: string;
            actionId?: string;
            /** @enum {string} */
            engagementType: SupersedingEngagementEngagementType;
            actor: components["schemas"]["SystemActor"] | components["schemas"]["ComputerVisionActor"] | components["schemas"]["MonitoringSpecialistActor"];
            /** @enum {string} */
            category: OutdoorEngagementResolutionCategory;
        };
        OutdoorEngagementClearedEvent: {
            id: string;
            /** Format: date-time */
            timestamp: string;
            /** @enum {string} */
            type: OutdoorEngagementClearedEventType;
            engagementId: string;
            locationId: string;
            blockId?: string;
            actionId?: string;
            /** @enum {string} */
            engagementType: SupersedingEngagementEngagementType;
            actor: components["schemas"]["SystemActor"] | components["schemas"]["ComputerVisionActor"] | components["schemas"]["MonitoringSpecialistActor"];
        };
        PagedEngagementEvents: {
            items: (components["schemas"]["OutdoorActivityCreatedEvent"] | components["schemas"]["OutdoorActivityAssignedEvent"] | components["schemas"]["OutdoorActivityStartedEvent"] | components["schemas"]["OutdoorActivityCompletedEvent"] | components["schemas"]["OutdoorEngagementCreatedEvent"] | components["schemas"]["OutdoorEngagementAssignedEvent"] | components["schemas"]["OutdoorEngagementResolvedEvent"] | components["schemas"]["OutdoorEngagementClearedEvent"])[];
            nextToken?: string;
        };
        ExistingSafeword: {
            name?: string;
            /** @enum {string} */
            type: ExistingSafewordType;
            value: string;
            id: string;
        };
        GetSafewordsResponse: {
            serial: number;
            safewords: components["schemas"]["ExistingSafeword"][];
        };
        BaseSafeword: {
            name?: string;
            /** @enum {string} */
            type: ExistingSafewordType;
            value: string;
        };
        UpdateSafewordRequest: {
            serial: number;
            safeword: components["schemas"]["BaseSafeword"];
        };
        UpdateSafewordResponse: {
            serial: number;
            safeword: components["schemas"]["ExistingSafeword"];
        };
        PatchServiceStatusSetting: {
            isEnabled?: boolean;
            /** Format: date-time */
            endTimestamp?: string;
        };
        PatchServiceStatus: {
            practiceMode?: components["schemas"]["PatchServiceStatusSetting"];
        };
        PatchMonitoring: {
            serviceStatus?: components["schemas"]["PatchServiceStatus"];
        };
        Interval: {
            offset: string;
            duration: string;
        };
        OutdoorMonitoring: {
            hasEligiblePlan: boolean;
            activeDailyIntervals?: components["schemas"]["Interval"][];
            isActive: boolean;
        };
        ServiceStatus: {
            professionalMonitoring: components["schemas"]["ServiceStatusSetting"];
            practiceMode: components["schemas"]["ServiceStatusSetting"];
            noAction?: components["schemas"]["ServiceStatusSetting"];
            outdoorMonitoring?: components["schemas"]["OutdoorMonitoring"];
        };
        Monitoring: {
            /** @enum {string} */
            monitoringServiceProviderId: MonitoringMonitoringServiceProviderId;
            serviceStatus: components["schemas"]["ServiceStatus"];
        };
        PrimaryContactName: {
            firstName: string;
            lastName: string;
        };
        Phone: {
            number: string;
        };
        PrimaryContact: {
            name?: components["schemas"]["PrimaryContactName"];
            phone: components["schemas"]["Phone"];
        };
        SecondaryContact: {
            name: string;
            phone: components["schemas"]["Phone"];
        };
        Contacts: {
            primaryContacts: components["schemas"]["PrimaryContact"][];
            secondaryContacts: components["schemas"]["SecondaryContact"][];
        };
        UpdateAddress: {
            street1: string;
            street2?: string;
            crossStreet?: string;
            city: string;
            state: string;
            zip: string;
            county: string;
            country: string;
            /** @enum {string} */
            propertyType?: AddressValidationResidenceType;
            /**
             * @deprecated
             * @enum {number}
             */
            residenceType?: PartialLocationAddressResidenceType;
            /** @enum {string} */
            timeZone: AddressCandidateTimeZone;
        };
        Address: {
            street1: string;
            street2?: string;
            crossStreet?: string;
            city: string;
            state: string;
            zip: string;
            county: string;
            country: string;
            /** @enum {string} */
            propertyType?: AddressValidationResidenceType;
            /**
             * @deprecated
             * @enum {number}
             */
            residenceType?: PartialLocationAddressResidenceType;
            /** @enum {string} */
            timeZone: AddressCandidateTimeZone;
            /** @deprecated */
            locationOffset: number;
        };
        DispatchNotesDto: {
            dispatchNotes?: string;
        };
        StreamableFile: Record<string, unknown>;
        EmailAddresses: {
            emailAddresses: string[];
        };
        PutTemplateIdDto: {
            templateId: number;
        };
        TemplateIdResponseDto: {
            templateId?: string;
        };
        USAddress: {
            street1: string;
            street2?: string;
            city: string;
            county?: string;
            /** @enum {string} */
            country: USAddressCountry;
            crossStreet?: string;
            /** @example America/New_York */
            timeZone: string;
            /** @enum {string} */
            propertyType: AddressValidationResidenceType;
            state: string;
            zipCode: string;
        };
        GBAddress: {
            street1: string;
            street2?: string;
            city: string;
            county?: string;
            /** @enum {string} */
            country: GBAddressCountry;
            crossStreet?: string;
            /** @example America/New_York */
            timeZone: string;
            /** @enum {string} */
            propertyType: AddressValidationResidenceType;
            postalCode: string;
        };
        MonitoringServiceProviderPhone: {
            number: string;
        };
        MonitoringServiceProviderContact: {
            name: string;
            phone: components["schemas"]["MonitoringServiceProviderPhone"];
        };
        MonitoringServiceProviderContacts: {
            primary: components["schemas"]["MonitoringServiceProviderContact"][];
            secondary: components["schemas"]["MonitoringServiceProviderContact"][];
        };
        MonitoringServiceProviderLocationDto: {
            locationId: string;
            /** @enum {string} */
            monitoringServiceProviderId: MonitoringMonitoringServiceProviderId;
            name: string;
            address: components["schemas"]["USAddress"] | components["schemas"]["GBAddress"];
            dispatchNotes?: string;
            contacts: components["schemas"]["MonitoringServiceProviderContacts"];
            jurisdictionId?: string;
            templateId?: number;
        };
        Workflow: {
            id: string;
            type: string;
            /** @enum {string} */
            status: PathsV1LocationsLocationIdWorkflowsGetParametersQueryStatus;
            startTimestamp: string;
            endTimestamp?: string;
        };
        SecuritasLocationIdentifiers: {
            /** @enum {string} */
            monitoringServiceProviderId: SecuritasLocationIdentifiersMonitoringServiceProviderId;
            siteNumber: number;
            csNo?: string;
            siteStatId?: string;
        };
        PatchSecuritasLocationIdentifiers: {
            /** @enum {string} */
            monitoringServiceProviderId?: SecuritasLocationIdentifiersMonitoringServiceProviderId;
            siteNumber?: number;
            csNo?: string;
            siteStatId?: string;
        };
        MonitoringSpecialistQueueSettingsDto: {
            limit?: number;
            acceptNew?: boolean;
            queues?: string[];
        };
        MonitoringSpecialistDto: {
            id: string;
            email: string;
            firstName?: string;
            lastName?: string;
            isActive?: boolean;
            isVerified?: boolean;
            role?: string;
            queueSettings?: components["schemas"]["MonitoringSpecialistQueueSettingsDto"];
        };
        LocationCameraCombinationCriteria: {
            /** @enum {string} */
            ruleType: LocationCameraCombinationCriteriaRuleType;
            locationId: string;
            cameraId: string;
            infractionTypes: DeviceInfractionDetailsInfractionType[];
        };
        ExclusionRule: {
            id: string;
            criteria: components["schemas"]["LocationCameraCombinationCriteria"];
            reason: string;
            createdBy: string;
            /** Format: date-time */
            createdAt: string;
            updatedBy: string;
            /** Format: date-time */
            updatedAt: string;
            /** Format: date-time */
            expiresAt?: string;
        };
        CreateExclusionRule: {
            criteria: components["schemas"]["LocationCameraCombinationCriteria"];
            reason: string;
            createdBy: string;
            /** Format: date-time */
            expiresAt?: string;
        };
    };
    responses: never;
    parameters: never;
    requestBodies: never;
    headers: never;
    pathItems: never;
};
export type $defs = Record<string, never>;
export interface operations {
    AddressValidationController_validateAddress_v1: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["AddressValidation"];
            };
        };
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["AddressValidationResult"];
                };
            };
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    LocationPermitsController_updateAgencyTypePermit_v1: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                locationId: string;
                agencyType: string;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["CreateLocationPermit"];
            };
        };
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["LocationPermit"];
                };
            };
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    LocationPermitsController_createLocationPermit_v1: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                locationId: string;
                agencyType: string;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["CreateLocationPermit"];
            };
        };
        responses: {
            201: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["LocationPermit"];
                };
            };
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    LocationPermitsController_deleteAgencyTypePermit_v1: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                locationId: string;
                agencyType: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            204: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    LocationPermitsController_getAllPermits_v1: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                locationId: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["LocationPermits"];
                };
            };
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    LocationPermitsController_getPermitsHistory_v1: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                locationId: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["LocationPermitHistories"];
                };
            };
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    LocationPermittingCommentsController_getLocationPermittingComments_v1: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                locationId: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["LocationPermittingCommentDto"][];
                };
            };
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    LocationPermittingCommentsController_addLocationPermittingComment_v1: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                locationId: string;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["LocationPermittingCommentRequestDto"];
            };
        };
        responses: {
            201: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["LocationPermittingCommentDto"];
                };
            };
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    LocationChangeController_getLocationChanges_v1: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description The id of the location to get changes for */
                locationId: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["LocationChange"][];
                };
            };
        };
    };
    LocationChangeController_createLocationChange_v1: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description The id of the location to create the change for */
                locationId: string;
            };
            cookie?: never;
        };
        /** @description The location change to create */
        requestBody: {
            content: {
                "application/json": components["schemas"]["CreateLocationChange"];
            };
        };
        responses: {
            201: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["LocationChange"];
                };
            };
        };
    };
    LocationChangeController_updateLocationChange_v1: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description The id of the location the change belongs to */
                locationId: string;
                /** @description The id of the location change to update */
                locationChangeId: string;
            };
            cookie?: never;
        };
        /** @description The location change to update */
        requestBody: {
            content: {
                "application/json": components["schemas"]["UpdateLocationChange"];
            };
        };
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["LocationChange"];
                };
            };
        };
    };
    LocationDeltasController_getDeltas_v1: {
        parameters: {
            query?: {
                /** @description Token for pagination */
                nextToken?: string;
                /** @description Max number of deltas per page */
                limit?: number;
            };
            header?: never;
            path: {
                locationId: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["PagedDeltaRecords"];
                };
            };
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    LocationsController_getLocation_v1: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                locationId: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Location"];
                };
            };
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    LocationAlarmsController_getAlarmSummaries_v1: {
        parameters: {
            query?: {
                interval?: string;
                limit?: number;
                nextToken?: string;
            };
            header?: never;
            path: {
                locationId: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["PagedAlarmSummaries"];
                };
            };
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    LocationAlarmsController_getAlarmDetails_v1: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                locationId: string;
                alarmId: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["AlarmDetails"];
                };
            };
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    LocationAlarmRecordingsController_createToken_v1: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                locationId: string;
                alarmId: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            201: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Token"];
                };
            };
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    LocationIdProviderController_getLocationIdentifiersByTransmitterCode_v1: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                monitoringServiceProviderId: string;
                transmitterCode: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Get LocationId from Transmitter Code */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["MonitoringServiceProviderLocation"];
                };
            };
            /** @description Invalid monitoringServiceProviderId */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    MetricsController_createMetric_v1: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["Metric"];
            };
        };
        responses: {
            /** @description Metric created */
            201: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    HealthController_check: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description The Health Check is successful */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        /** @example ok */
                        status?: string;
                        /**
                         * @example {
                         *       "database": {
                         *         "status": "up"
                         *       }
                         *     }
                         */
                        info?: {
                            [key: string]: {
                                status: string;
                            } & {
                                [key: string]: unknown;
                            };
                        } | null;
                        /** @example {} */
                        error?: {
                            [key: string]: {
                                status: string;
                            } & {
                                [key: string]: unknown;
                            };
                        } | null;
                        /**
                         * @example {
                         *       "database": {
                         *         "status": "up"
                         *       }
                         *     }
                         */
                        details?: {
                            [key: string]: {
                                status: string;
                            } & {
                                [key: string]: unknown;
                            };
                        };
                    };
                };
            };
            /** @description The Health Check is not successful */
            503: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        /** @example error */
                        status?: string;
                        /**
                         * @example {
                         *       "database": {
                         *         "status": "up"
                         *       }
                         *     }
                         */
                        info?: {
                            [key: string]: {
                                status: string;
                            } & {
                                [key: string]: unknown;
                            };
                        } | null;
                        /**
                         * @example {
                         *       "redis": {
                         *         "status": "down",
                         *         "message": "Could not connect"
                         *       }
                         *     }
                         */
                        error?: {
                            [key: string]: {
                                status: string;
                            } & {
                                [key: string]: unknown;
                            };
                        } | null;
                        /**
                         * @example {
                         *       "database": {
                         *         "status": "up"
                         *       },
                         *       "redis": {
                         *         "status": "down",
                         *         "message": "Could not connect"
                         *       }
                         *     }
                         */
                        details?: {
                            [key: string]: {
                                status: string;
                            } & {
                                [key: string]: unknown;
                            };
                        };
                    };
                };
            };
        };
    };
    HealthController_checkLiveness: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description The Health Check is successful */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        /** @example ok */
                        status?: string;
                        /**
                         * @example {
                         *       "database": {
                         *         "status": "up"
                         *       }
                         *     }
                         */
                        info?: {
                            [key: string]: {
                                status: string;
                            } & {
                                [key: string]: unknown;
                            };
                        } | null;
                        /** @example {} */
                        error?: {
                            [key: string]: {
                                status: string;
                            } & {
                                [key: string]: unknown;
                            };
                        } | null;
                        /**
                         * @example {
                         *       "database": {
                         *         "status": "up"
                         *       }
                         *     }
                         */
                        details?: {
                            [key: string]: {
                                status: string;
                            } & {
                                [key: string]: unknown;
                            };
                        };
                    };
                };
            };
            /** @description The Health Check is not successful */
            503: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        /** @example error */
                        status?: string;
                        /**
                         * @example {
                         *       "database": {
                         *         "status": "up"
                         *       }
                         *     }
                         */
                        info?: {
                            [key: string]: {
                                status: string;
                            } & {
                                [key: string]: unknown;
                            };
                        } | null;
                        /**
                         * @example {
                         *       "redis": {
                         *         "status": "down",
                         *         "message": "Could not connect"
                         *       }
                         *     }
                         */
                        error?: {
                            [key: string]: {
                                status: string;
                            } & {
                                [key: string]: unknown;
                            };
                        } | null;
                        /**
                         * @example {
                         *       "database": {
                         *         "status": "up"
                         *       },
                         *       "redis": {
                         *         "status": "down",
                         *         "message": "Could not connect"
                         *       }
                         *     }
                         */
                        details?: {
                            [key: string]: {
                                status: string;
                            } & {
                                [key: string]: unknown;
                            };
                        };
                    };
                };
            };
        };
    };
    HealthController_checkReadiness: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description The Health Check is successful */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        /** @example ok */
                        status?: string;
                        /**
                         * @example {
                         *       "database": {
                         *         "status": "up"
                         *       }
                         *     }
                         */
                        info?: {
                            [key: string]: {
                                status: string;
                            } & {
                                [key: string]: unknown;
                            };
                        } | null;
                        /** @example {} */
                        error?: {
                            [key: string]: {
                                status: string;
                            } & {
                                [key: string]: unknown;
                            };
                        } | null;
                        /**
                         * @example {
                         *       "database": {
                         *         "status": "up"
                         *       }
                         *     }
                         */
                        details?: {
                            [key: string]: {
                                status: string;
                            } & {
                                [key: string]: unknown;
                            };
                        };
                    };
                };
            };
            /** @description The Health Check is not successful */
            503: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        /** @example error */
                        status?: string;
                        /**
                         * @example {
                         *       "database": {
                         *         "status": "up"
                         *       }
                         *     }
                         */
                        info?: {
                            [key: string]: {
                                status: string;
                            } & {
                                [key: string]: unknown;
                            };
                        } | null;
                        /**
                         * @example {
                         *       "redis": {
                         *         "status": "down",
                         *         "message": "Could not connect"
                         *       }
                         *     }
                         */
                        error?: {
                            [key: string]: {
                                status: string;
                            } & {
                                [key: string]: unknown;
                            };
                        } | null;
                        /**
                         * @example {
                         *       "database": {
                         *         "status": "up"
                         *       },
                         *       "redis": {
                         *         "status": "down",
                         *         "message": "Could not connect"
                         *       }
                         *     }
                         */
                        details?: {
                            [key: string]: {
                                status: string;
                            } & {
                                [key: string]: unknown;
                            };
                        };
                    };
                };
            };
        };
    };
    HealthController_checkStartup: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description The Health Check is successful */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        /** @example ok */
                        status?: string;
                        /**
                         * @example {
                         *       "database": {
                         *         "status": "up"
                         *       }
                         *     }
                         */
                        info?: {
                            [key: string]: {
                                status: string;
                            } & {
                                [key: string]: unknown;
                            };
                        } | null;
                        /** @example {} */
                        error?: {
                            [key: string]: {
                                status: string;
                            } & {
                                [key: string]: unknown;
                            };
                        } | null;
                        /**
                         * @example {
                         *       "database": {
                         *         "status": "up"
                         *       }
                         *     }
                         */
                        details?: {
                            [key: string]: {
                                status: string;
                            } & {
                                [key: string]: unknown;
                            };
                        };
                    };
                };
            };
            /** @description The Health Check is not successful */
            503: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        /** @example error */
                        status?: string;
                        /**
                         * @example {
                         *       "database": {
                         *         "status": "up"
                         *       }
                         *     }
                         */
                        info?: {
                            [key: string]: {
                                status: string;
                            } & {
                                [key: string]: unknown;
                            };
                        } | null;
                        /**
                         * @example {
                         *       "redis": {
                         *         "status": "down",
                         *         "message": "Could not connect"
                         *       }
                         *     }
                         */
                        error?: {
                            [key: string]: {
                                status: string;
                            } & {
                                [key: string]: unknown;
                            };
                        } | null;
                        /**
                         * @example {
                         *       "database": {
                         *         "status": "up"
                         *       },
                         *       "redis": {
                         *         "status": "down",
                         *         "message": "Could not connect"
                         *       }
                         *     }
                         */
                        details?: {
                            [key: string]: {
                                status: string;
                            } & {
                                [key: string]: unknown;
                            };
                        };
                    };
                };
            };
        };
    };
    LocationEngagementsController_createToken_v1: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                locationId: string;
                engagementId: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            201: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Token"];
                };
            };
            /** @description Not Found */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    LocationEngagementsController_getRecordings_v1: {
        parameters: {
            query: {
                start: string;
                end: string;
            };
            header?: never;
            path: {
                locationId: string;
                engagementId: string;
                cameraId: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["EngagementCameraRecording"];
                };
            };
            /** @description Unauthorized */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Not Found */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    LocationCamerasController_getCameras_v1: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                locationId: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Camera"][];
                };
            };
        };
    };
    LocationCameraDeviceController_patchCameraDevice_v1: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                locationId: string;
                deviceId: string;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["PatchLocationCameraDevice"];
            };
        };
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["LocationCameraDevice"];
                };
            };
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            403: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    SearchController_search_v1: {
        parameters: {
            query: {
                /** @description Valid Search Identifier */
                type: PathsV1SearchGetParametersQueryType;
                /** @description Identifier for the search type */
                id: string;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["LocationSearchResponseDto"];
                };
            };
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    ModerationController_getModerationEvents_v1: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                locationId: string;
                eventId: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ModerationEvent"];
                };
            };
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    ModerationController_deleteModerationEvent_v1: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                locationId: string;
                eventId: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    ModerationController_updateModerationEvent_v1: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                locationId: string;
                eventId: string;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["UpdateModerationEvent"];
            };
        };
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ModerationEvent"];
                };
            };
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Some actions failed to complete */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ModerationEvent"];
                };
            };
        };
    };
    ModerationController_getAllModerationEvents_v1: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                locationId: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ModerationEvent"][];
                };
            };
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    ModerationController_createModerationEvent_v1: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                locationId: string;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["ModerationEventSource"];
            };
        };
        responses: {
            201: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ModerationEvent"];
                };
            };
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    EngagementsController_getEngagement_v1: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                engagementId: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["OutdoorEngagement"];
                };
            };
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    EngagementsController_getAllEngagements_v1: {
        parameters: {
            query?: {
                /** @description Filter by location ID */
                locationId?: string;
                /** @description Filter by specialist ID */
                specialistId?: string;
                limit?: number;
                nextToken?: string;
                /** @description Time range to get engagements created in the range [startDateTime, endDateTime] */
                interval?: string;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["PagedEngagements"];
                };
            };
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    EngagementsController_getActivities_v1: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                engagementId: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": (components["schemas"]["MonitoringSpecialistAssignmentOutdoorActivity"] | components["schemas"]["MonitoringSpecialistTriageOutdoorActivity"] | components["schemas"]["AutoClearCooldownFromFeedOutdoorActivity"] | components["schemas"]["AutoClearCooldownFromInvestigateOutdoorActivity"] | components["schemas"]["QuickClearFromInvestigateOutdoorActivity"] | components["schemas"]["EscalateToIntrusionWithDescriptionOutdoorActivity"] | components["schemas"]["RecentHistoryOutdoorActivity"] | components["schemas"]["TwoWayAudioCheckpointOutdoorActivity"] | components["schemas"]["FamiliarFaceReviewWithoutAIOutdoorActivity"] | components["schemas"]["TwoWayAudioInteractionOutdoorActivity"] | components["schemas"]["FinalDocumentationOutdoorActivity"])[];
                };
            };
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    EngagementsController_getEngagementEvents_v1: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                engagementId: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["PagedEngagementEvents"];
                };
            };
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    SafeWordsController_getSafeWords_v1: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                locationId: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["GetSafewordsResponse"];
                };
            };
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    SafeWordsController_putSafeWord_v1: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                locationId: string;
                safeWordId: string;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["UpdateSafewordRequest"];
            };
        };
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["UpdateSafewordResponse"];
                };
            };
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    LocationMonitoringController_putMonitoring_v1: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                locationId: string;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["PatchMonitoring"];
            };
        };
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Monitoring"];
                };
            };
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Returned when trying to modify the monitoring service provider status without the required scope. */
            403: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Returned when trying to modify the monitoring service provider status to a state that does not align with the service status */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    LocationContactsController_putContacts_v1: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                locationId: string;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["Contacts"];
            };
        };
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Contacts"];
                };
            };
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            403: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    LocationAddressController_putAddress_v1: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                locationId: string;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["UpdateAddress"];
            };
        };
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Address"];
                };
            };
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    LocationDispatchNotesController_updateDispatchNotes_v1: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                locationId: string;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["DispatchNotesDto"];
            };
        };
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["DispatchNotesDto"];
                };
            };
            403: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    LocationCertificatesController_getLocationCertificate_v1: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                locationId: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Returns location certificates as a PDF file */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/pdf": components["schemas"]["StreamableFile"];
                };
            };
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            403: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    LocationCertificatesController_sendLocationCertificateEmail_v1: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                locationId: string;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["EmailAddresses"];
            };
        };
        responses: {
            /** @description Successfully sent location certificates via email */
            201: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["EmailAddresses"];
                };
            };
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            403: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    LocationTemplateIdController_updateTemplateId_v1: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                locationId: string;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["PutTemplateIdDto"];
            };
        };
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["TemplateIdResponseDto"];
                };
            };
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    MspLocationsController_getLocation_v1: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                locationId: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["MonitoringServiceProviderLocationDto"];
                };
            };
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    LocationWorkflowsController_getWorkflows_v1: {
        parameters: {
            query?: {
                /** @description Filter workflows by status */
                status?: PathsV1LocationsLocationIdWorkflowsGetParametersQueryStatus;
            };
            header?: never;
            path: {
                locationId: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Returns location workflows */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Workflow"][];
                };
            };
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            403: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    MspLocationIdentifiersController_getMspIdentifiers_v1: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                locationId: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["SecuritasLocationIdentifiers"];
                };
            };
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    MspLocationIdentifiersController_patchMspIdentifiers_v1: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                locationId: string;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["PatchSecuritasLocationIdentifiers"];
            };
        };
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["PatchSecuritasLocationIdentifiers"];
                };
            };
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    SpecialistsController_getSpecialist_v1: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                monitoringServiceProviderId: string;
                specialistId: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["MonitoringSpecialistDto"];
                };
            };
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    SpecialistsController_getAllSpecialists_v1: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                monitoringServiceProviderId: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["MonitoringSpecialistDto"][];
                };
            };
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    ExclusionRuleController_getExclusionRule_v1: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ExclusionRule"];
                };
            };
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    ExclusionRuleController_deleteExclusionRule_v1: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    ExclusionRuleController_getAllExclusionRules_v1: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ExclusionRule"][];
                };
            };
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    ExclusionRuleController_createExclusionRule_v1: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["CreateExclusionRule"];
            };
        };
        responses: {
            201: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ExclusionRule"];
                };
            };
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
}
export enum PathsV1SearchGetParametersQueryType {
    cameraId = "cameraId"
}
export enum PathsV1LocationsLocationIdWorkflowsGetParametersQueryStatus {
    Running = "Running",
    Finished = "Finished",
    Failed = "Failed",
    Cancelled = "Cancelled",
    Unknown = "Unknown"
}
export enum AddressValidationResidenceType {
    Apartment = "Apartment",
    House = "House",
    Commercial = "Commercial"
}
export enum AddressCorrectionType {
    ZipCode = "ZipCode",
    CitySpelling = "CitySpelling",
    State = "State",
    MultipleMatches = "MultipleMatches",
    StreetCardinalDirection = "StreetCardinalDirection",
    StreetComponent = "StreetComponent",
    StreetSpelling = "StreetSpelling",
    StreetAbbreviation = "StreetAbbreviation",
    MultipleZip4Matches = "MultipleZip4Matches",
    StreetPreferredName = "StreetPreferredName",
    CityPreferredName = "CityPreferredName",
    City = "City",
    ZipCodeUpdated = "ZipCodeUpdated"
}
export enum AddressCorrectionSeverity {
    NonTrivial = "NonTrivial",
    Trivial = "Trivial"
}
export enum AddressIssueType {
    GeneralDeliveryAddress = "GeneralDeliveryAddress",
    POBox = "POBox",
    RuralRoute = "RuralRoute",
    NoMatchFound = "NoMatchFound",
    InvalidCityStateZip = "InvalidCityStateZip",
    UnknownAddress = "UnknownAddress",
    AddressNotFound = "AddressNotFound",
    MissingSecondaryAddress = "MissingSecondaryAddress",
    InsufficientAddressData = "InsufficientAddressData",
    DualAddress = "DualAddress",
    UniqueZip = "UniqueZip",
    NewAddress = "NewAddress",
    UnrecognizedSecondaryAddress = "UnrecognizedSecondaryAddress",
    MagnetStreetSyndrome = "MagnetStreetSyndrome",
    NoStreetDelivery = "NoStreetDelivery",
    MilitaryOrDiplomaticZip = "MilitaryOrDiplomaticZip"
}
export enum AddressIssueSeverity {
    Critical = "Critical",
    Warning = "Warning"
}
export enum AddressCandidateResidentialDeliveryIndicator {
    Residential = "Residential",
    Commercial = "Commercial",
    Other = "Other"
}
export enum AddressCandidateTimeZone {
    America_New_York = "America/New_York",
    America_Chicago = "America/Chicago",
    America_Denver = "America/Denver",
    America_Los_Angeles = "America/Los_Angeles",
    America_Puerto_Rico = "America/Puerto_Rico",
    America_Phoenix = "America/Phoenix",
    Pacific_Honolulu = "Pacific/Honolulu",
    America_Anchorage = "America/Anchorage",
    Europe_London = "Europe/London",
    Pacific_Guam = "Pacific/Guam",
    Unknown = "Unknown",
    Unresolved = "Unresolved"
}
export enum CreateLocationPermitSource {
    SimpliSafe = "SimpliSafe",
    Customer = "Customer",
    MonitoringServiceProvider = "MonitoringServiceProvider"
}
export enum LocationPermitHistoryDtoChangeType {
    Created = "Created",
    Updated = "Updated",
    UpdatedStatus = "UpdatedStatus",
    UpdatedPermitNumber = "UpdatedPermitNumber",
    UpdatedExpiration = "UpdatedExpiration",
    Deleted = "Deleted"
}
export enum MonitoringLocationChangeAddressCountry {
    US = "US",
    GB = "GB"
}
export enum MonitoringLocationChangeAddressTimeZone {
    America_New_York = "America/New_York",
    America_Chicago = "America/Chicago",
    America_Denver = "America/Denver",
    America_Los_Angeles = "America/Los_Angeles",
    America_Puerto_Rico = "America/Puerto_Rico",
    America_Phoenix = "America/Phoenix",
    Pacific_Honolulu = "Pacific/Honolulu",
    America_Anchorage = "America/Anchorage",
    Europe_London = "Europe/London",
    Pacific_Guam = "Pacific/Guam",
    Unknown = "Unknown"
}
export enum LocationChangeState {
    pending = "pending",
    completed = "completed",
    cancelled = "cancelled"
}
export enum PartialLocationAddressResidenceType {
    Value0 = 0,
    Value1 = 1,
    Value2 = 2,
    Value3 = 3
}
export enum LocationDeltaRecordResource {
    Location = "Location"
}
export enum SafeWordDeltaRecordResource {
    SafeWord = "SafeWord"
}
export enum AlarmMonitoringStateState {
    Unknown = "Unknown",
    Unmonitored = "Unmonitored",
    Queued = "Queued",
    Active = "Active",
    Complete = "Complete"
}
export enum AlarmMonitoringStateDisposition {
    Cancelled = "Cancelled",
    CustomerNotified = "CustomerNotified",
    DispatchDeclined = "DispatchDeclined",
    DispatchRequested = "DispatchRequested",
    NoAction = "NoAction",
    Unknown = "Unknown",
    Unmonitored = "Unmonitored"
}
export enum AlarmMonitoringStateDispositionReason {
    Unknown = "Unknown",
    ElectronicCancellation = "ElectronicCancellation",
    SMSMessage = "SMSMessage",
    CustomerContactCall = "CustomerContactCall",
    KeyPad = "KeyPad",
    KeyFob = "KeyFob",
    NoResponse = "NoResponse",
    ElectronicEscalation = "ElectronicEscalation"
}
export enum PhoneNumberType {
    Unknown = "Unknown",
    Other = "Other",
    Mobile = "Mobile",
    Home = "Home",
    Work = "Work",
    Office = "Office",
    Dispatcher = "Dispatcher"
}
export enum AlarmCustomerContactStateState {
    Unknown = "Unknown",
    Pending = "Pending",
    Contacting = "Contacting",
    Contacted = "Contacted",
    HelpRequested = "HelpRequested",
    CancelRequested = "CancelRequested",
    Notified = "Notified",
    HungUp = "HungUp",
    LeftMessage = "LeftMessage",
    Unresponsive = "Unresponsive",
    Responding = "Responding",
    NotContacted = "NotContacted",
    Failed = "Failed"
}
export enum AlarmCustomerContactStateVerificationState {
    Unknown = "Unknown",
    NotVerified = "NotVerified",
    ValidSafeword = "ValidSafeword",
    NoSafeword = "NoSafeword",
    InvalidSafeword = "InvalidSafeword"
}
export enum AgencyType {
    Unknown = "Unknown",
    Other = "Other",
    Fire = "Fire",
    Medical = "Medical",
    Police = "Police",
    Guard = "Guard"
}
export enum DispatchState {
    Unknown = "Unknown",
    NotRequested = "NotRequested",
    Contacting = "Contacting",
    Contacted = "Contacted",
    Requested = "Requested",
    Declined = "Declined",
    CancelRequested = "CancelRequested",
    Failed = "Failed"
}
export enum DispatchDispatchDeclinedReason {
    ExcessiveFalseAlarms = "ExcessiveFalseAlarms",
    ExpiredOrSuspendedPermit = "ExpiredOrSuspendedPermit",
    InvalidAddress = "InvalidAddress",
    NoPermit = "NoPermit",
    DidNotMeetRequirements = "DidNotMeetRequirements",
    Other = "Other",
    Unknown = "Unknown"
}
export enum AlarmSummaryCategory {
    Unknown = "Unknown",
    Test = "Test",
    CarbonMonoxide = "CarbonMonoxide",
    Fire = "Fire",
    Medical = "Medical",
    Duress = "Duress",
    Panic = "Panic",
    Burglary = "Burglary",
    Water = "Water",
    Temperature = "Temperature",
    Alert = "Alert",
    OutdoorConfirmedBurglary = "OutdoorConfirmedBurglary",
    OutdoorPossibleBurglary = "OutdoorPossibleBurglary",
    OutdoorConfirmedFire = "OutdoorConfirmedFire",
    OutdoorPossibleFire = "OutdoorPossibleFire",
    OutdoorConfirmedMedical = "OutdoorConfirmedMedical"
}
export enum AlarmSummaryDisposition {
    ActualAlarm = "ActualAlarm",
    Alert = "Alert",
    FalseAlarm = "FalseAlarm",
    NoAction = "NoAction",
    Test = "Test",
    Unknown = "Unknown"
}
export enum TimelineAlarmEventType {
    AlarmSignalEvent = "AlarmSignalEvent",
    MonitoringServiceProviderAlarmSignalEvent = "MonitoringServiceProviderAlarmSignalEvent",
    MonitoringSpecialistEvent = "MonitoringSpecialistEvent",
    MonitoringServiceProviderAsapMessageEvent = "MonitoringServiceProviderAsapMessageEvent",
    MonitoringServiceProviderLocationIssueEvent = "MonitoringServiceProviderLocationIssueEvent",
    CameraRecordingQualityEvent = "CameraRecordingQualityEvent"
}
export enum TimelineAlarmSignalEventType {
    AlarmSignalEvent = "AlarmSignalEvent"
}
export enum TimelineMonitoringServiceProviderAlarmSignalEventType {
    MonitoringServiceProviderAlarmSignalEvent = "MonitoringServiceProviderAlarmSignalEvent"
}
export enum TimelineMonitoringServiceProviderAlarmSignalEventMonitoringServiceProviderAccountStatus {
    Unknown = "Unknown",
    Active = "Active",
    InTest = "InTest",
    OutOfService = "OutOfService"
}
export enum TimelineMonitoringServiceProviderAsapMessageEventType {
    MonitoringServiceProviderAsapMessageEvent = "MonitoringServiceProviderAsapMessageEvent"
}
export enum TimelineMonitoringServiceProviderAsapMessageEventMessageType {
    Unknown = "Unknown",
    Other = "Other",
    Api = "Api",
    Accepted = "Accepted",
    DispatchRequested = "DispatchRequested",
    SupplementalDispatch = "SupplementalDispatch",
    Cancelled = "Cancelled",
    Chat = "Chat",
    NoPsap = "NoPsap",
    ApiError = "ApiError",
    Timeout = "Timeout"
}
export enum TimelineMonitoringServiceProviderLocationIssueEventType {
    MonitoringServiceProviderLocationIssueEvent = "MonitoringServiceProviderLocationIssueEvent"
}
export enum TimelineMonitoringServiceProviderLocationIssueEventLocationIssue {
    Unknown = "Unknown",
    Other = "Other",
    BadAddress = "BadAddress",
    BadPhoneNumber = "BadPhoneNumber"
}
export enum AgencyCallRecipientType {
    Agency = "Agency",
    CustomerContact = "CustomerContact",
    Other = "Other"
}
export enum CallDetailsDisposition {
    Unknown = "Unknown",
    Other = "Other",
    CallConnected = "CallConnected",
    Contacted = "Contacted",
    ContactedAfterLongHoldTime = "ContactedAfterLongHoldTime",
    ContactResponding = "ContactResponding",
    Unresponsive = "Unresponsive",
    ContactUnavailable = "ContactUnavailable",
    NoSafeword = "NoSafeword",
    IncorrectData = "IncorrectData",
    VoicemailLeftMessage = "VoicemailLeftMessage",
    VoicemailNoMessage = "VoicemailNoMessage",
    StraightToVoicemail = "StraightToVoicemail",
    AnsweringService = "AnsweringService",
    PagerCallbackRequested = "PagerCallbackRequested",
    LineBusy = "LineBusy",
    NoAnswer = "NoAnswer",
    HungUp = "HungUp",
    DoNotCall = "DoNotCall",
    MedicalDispatchRequested = "MedicalDispatchRequested",
    MedicalDispatchDeclined = "MedicalDispatchDeclined",
    MedicalDispatchCancelRequested = "MedicalDispatchCancelRequested",
    MedicalUpdated = "MedicalUpdated",
    FireDispatchRequested = "FireDispatchRequested",
    FireDispatchDeclined = "FireDispatchDeclined",
    FireDispatchCancelRequested = "FireDispatchCancelRequested",
    FireUpdated = "FireUpdated",
    PoliceDispatchRequested = "PoliceDispatchRequested",
    PoliceDispatchDeclined = "PoliceDispatchDeclined",
    PoliceDispatchCancelRequested = "PoliceDispatchCancelRequested",
    PoliceUpdated = "PoliceUpdated",
    GuardDispatchRequested = "GuardDispatchRequested",
    GuardDispatchDeclined = "GuardDispatchDeclined",
    GuardDispatchCancelRequested = "GuardDispatchCancelRequested",
    GuardUpdated = "GuardUpdated",
    InvalidPermit = "InvalidPermit",
    Aborted = "Aborted",
    NumberMissing = "NumberMissing",
    NoCustomerContact = "NoCustomerContact",
    NoPrimaryContact = "NoPrimaryContact",
    WrongNumber = "WrongNumber",
    DidNotVector = "DidNotVector",
    NumberInvalid = "NumberInvalid",
    ExtensionInvalid = "ExtensionInvalid",
    FaxMachine = "FaxMachine",
    NumberDisconnected = "NumberDisconnected",
    ErrorMessage = "ErrorMessage",
    NumberChanged = "NumberChanged",
    NumberNotInService = "NumberNotInService",
    NumberTemporarilyNotInService = "NumberTemporarilyNotInService",
    IvrError = "IvrError",
    LineTrouble = "LineTrouble"
}
export enum TimelineMonitoringSpecialistEventType {
    MonitoringSpecialistEvent = "MonitoringSpecialistEvent"
}
export enum TimelineMonitoringSpecialistEventAction {
    Unknown = "Unknown",
    Other = "Other",
    AccessedAlarm = "AccessedAlarm",
    CallInitiated = "CallInitiated",
    CallCompleted = "CallCompleted",
    CustomerContactRequestedDispatch = "CustomerContactRequestedDispatch",
    CustomerContactDidNotRequestDispatch = "CustomerContactDidNotRequestDispatch",
    CustomerContactNotified = "CustomerContactNotified",
    CustomerContactResponding = "CustomerContactResponding",
    CustomerContactConfirmedAlarm = "CustomerContactConfirmedAlarm",
    CustomerContactVerificationInvalidSafeword = "CustomerContactVerificationInvalidSafeword",
    CustomerContactVerificationValidSafeword = "CustomerContactVerificationValidSafeword",
    CustomerContactVerificationNoSafeword = "CustomerContactVerificationNoSafeword",
    CustomerContactCallIn = "CustomerContactCallIn",
    DispatcherConfirmedAlarm = "DispatcherConfirmedAlarm",
    MedicalDispatchRequested = "MedicalDispatchRequested",
    MedicalDispatchDeclined = "MedicalDispatchDeclined",
    MedicalDispatchCancelRequested = "MedicalDispatchCancelRequested",
    FireDispatchRequested = "FireDispatchRequested",
    FireDispatchDeclined = "FireDispatchDeclined",
    FireDispatchCancelRequested = "FireDispatchCancelRequested",
    PoliceDispatchRequested = "PoliceDispatchRequested",
    PoliceDispatchDeclined = "PoliceDispatchDeclined",
    PoliceDispatchCancelRequested = "PoliceDispatchCancelRequested",
    GuardDispatchRequested = "GuardDispatchRequested",
    GuardDispatchDeclined = "GuardDispatchDeclined",
    GuardDispatchCancelRequested = "GuardDispatchCancelRequested",
    NoFurtherActionRequired = "NoFurtherActionRequired",
    CompletedProcessing = "CompletedProcessing",
    VisualVerificationNoHumanActivityObserved = "VisualVerificationNoHumanActivityObserved",
    VisualVerificationHumanActivityObserved = "VisualVerificationHumanActivityObserved",
    VisualVerificationThreateningActivityObserved = "VisualVerificationThreateningActivityObserved",
    VisualVerificationInaccessible = "VisualVerificationInaccessible",
    AccountIncorrectAddress = "AccountIncorrectAddress",
    AccountInvalidPhone = "AccountInvalidPhone",
    AccountInvalidPermit = "AccountInvalidPermit",
    AccountPlacedOnTest = "AccountPlacedOnTest",
    AccountRemovedFromTest = "AccountRemovedFromTest",
    AccountPlacedInService = "AccountPlacedInService",
    AccountRemovedFromService = "AccountRemovedFromService",
    LiveGuardProtectionInitiated = "LiveGuardProtectionInitiated",
    LiveGuardProtectionNoHumanActivityObserved = "LiveGuardProtectionNoHumanActivityObserved",
    LiveGuardProtectionHumanActivityObserved = "LiveGuardProtectionHumanActivityObserved",
    LiveGuardProtectionRecordedHumanActivityObserved = "LiveGuardProtectionRecordedHumanActivityObserved",
    LiveGuardProtectionUnableToViewVideo = "LiveGuardProtectionUnableToViewVideo",
    LiveGuardProtectionProceedingToTwoWayAudio = "LiveGuardProtectionProceedingToTwoWayAudio",
    LiveGuardProtectionTwoWayAudioQualityRatedGood = "LiveGuardProtectionTwoWayAudioQualityRatedGood",
    LiveGuardProtectionTwoWayAudioQualityRatedFair = "LiveGuardProtectionTwoWayAudioQualityRatedFair",
    LiveGuardProtectionTwoWayAudioQualityRatedPoor = "LiveGuardProtectionTwoWayAudioQualityRatedPoor",
    LiveGuardProtectionTwoWayAudioQualityRatedOther = "LiveGuardProtectionTwoWayAudioQualityRatedOther",
    LiveGuardProtectionHostileThreateningSuspiciousPerson = "LiveGuardProtectionHostileThreateningSuspiciousPerson",
    LiveGuardProtectionHostileThreateningSuspiciousBehaviorStopped = "LiveGuardProtectionHostileThreateningSuspiciousBehaviorStopped",
    LiveGuardProtectionHostileThreateningSuspiciousBehaviorContinued = "LiveGuardProtectionHostileThreateningSuspiciousBehaviorContinued",
    LiveGuardProtectionViolenceObserved = "LiveGuardProtectionViolenceObserved",
    LiveGuardProtectionUnattendedMinorOrInappropriateBehavior = "LiveGuardProtectionUnattendedMinorOrInappropriateBehavior",
    LiveGuardProtectionUniformedPoliceOnSite = "LiveGuardProtectionUniformedPoliceOnSite",
    PracticeModeCall = "PracticeModeCall",
    NumberMissing = "NumberMissing",
    NoCustomerContact = "NoCustomerContact",
    NoPrimaryContact = "NoPrimaryContact",
    UnverifiedCustomerRequestedDispatch = "UnverifiedCustomerRequestedDispatch"
}
export enum TimelineCameraRecordingQualityEventType {
    CameraRecordingQualityEvent = "CameraRecordingQualityEvent"
}
export enum TimelineCameraRecordingQualityEventTrigger {
    Unknown = "Unknown",
    Other = "Other",
    Creation = "Creation",
    Access = "Access",
    Finalization = "Finalization"
}
export enum MetricDestinations {
    audit = "audit",
    analytics = "analytics",
    telemetry = "telemetry"
}
export enum EngagementCameraRecordingDisallowedReason {
    UserNotAllowedRecordingAccess = "UserNotAllowedRecordingAccess",
    CustomerOptedOutOfQualityAssurance = "CustomerOptedOutOfQualityAssurance",
    CustomerDeletedRecording = "CustomerDeletedRecording"
}
export enum LocationCameraDeviceCategory {
    camera = "camera"
}
export enum SuccessActionResultType {
    Success = "Success"
}
export enum FailureActionResultType {
    Failure = "Failure"
}
export enum ClearLocationCommunicationActionType {
    ClearLocationCommunication = "ClearLocationCommunication"
}
export enum ClearLocationCommunicationActionStatus {
    Pending = "Pending",
    Active = "Active",
    Completed = "Completed",
    Failed = "Failed"
}
export enum CustomerCommunicationActionType {
    CustomerCommunication = "CustomerCommunication"
}
export enum CustomerEscalationActionType {
    CustomerEscalation = "CustomerEscalation"
}
export enum DuplicateClearanceReasonType {
    DuplicateClearance = "DuplicateClearance"
}
export enum CameraNotEnrolledReasonType {
    CameraNotEnrolled = "CameraNotEnrolled"
}
export enum LocationNotSubscribedReasonType {
    LocationNotSubscribed = "LocationNotSubscribed"
}
export enum AmbiguousCameraReasonType {
    AmbiguousCamera = "AmbiguousCamera"
}
export enum IgnoredActionType {
    Ignored = "Ignored"
}
export enum UnenrollCameraActionType {
    UnenrollCamera = "UnenrollCamera"
}
export enum DeviceType {
    Camera = "Camera"
}
export enum DeviceInfractionDetailsType {
    DeviceInfraction = "DeviceInfraction"
}
export enum DeviceInfractionDetailsInfractionType {
    ImproperDevicePlacement = "ImproperDevicePlacement",
    HighEngagementVolume = "HighEngagementVolume",
    HighPasserbyVolume = "HighPasserbyVolume",
    InappropriateBehaviorWitnessed = "InappropriateBehaviorWitnessed",
    GrossMisconduct = "GrossMisconduct"
}
export enum AutomatedDeviceInfractionDetailsType {
    AutomatedDeviceInfraction = "AutomatedDeviceInfraction"
}
export enum AutomatedDeviceInfractionDetailsEnforcementLevel {
    FirstWarning = "FirstWarning",
    FinalWarning = "FinalWarning",
    Unenroll = "Unenroll"
}
export enum LocationCommunicationActionType {
    LocationCommunication = "LocationCommunication"
}
export enum UserCommunicationActionType {
    UserCommunication = "UserCommunication"
}
export enum AddressGateCodeIssueModerationDetailsType {
    AddressGateCodeIssue = "AddressGateCodeIssue"
}
export enum AddressMissingBusinessNameModerationDetailsType {
    AddressMissingBusinessNameIssue = "AddressMissingBusinessNameIssue"
}
export enum AddressUnableToLocateEntryKind {
    MissingOrIncorrectCrossStreet = "MissingOrIncorrectCrossStreet",
    UnableToGeoLocate = "UnableToGeoLocate",
    PSAPUnableToLocate = "PSAPUnableToLocate"
}
export enum AddressUnableToLocateModerationDetailsType {
    AddressUnableToLocateIssue = "AddressUnableToLocateIssue"
}
export enum AddressValidationIssueEntryKind {
    MissingDirectionalIndicator = "MissingDirectionalIndicator",
    MissingOrIncorrectAddress = "MissingOrIncorrectAddress",
    MissingOrIncorrectCityorState = "MissingOrIncorrectCityorState",
    MissingOrIncorrectUnit = "MissingOrIncorrectUnit",
    MissingStreetName = "MissingStreetName"
}
export enum AddressValidationIssueModerationDetailsType {
    AddressValidationIssue = "AddressValidationIssue"
}
export enum AddressPoBoxIssueModerationDetailsType {
    AddressPoBoxIssue = "AddressPoBoxIssue"
}
export enum AddressWrongAddressTypeIssueModerationDetailsType {
    AddressWrongAddressTypeIssue = "AddressWrongAddressTypeIssue"
}
export enum PhoneBadNumberIssueEntryKind {
    PhoneNumberDisconnected = "PhoneNumberDisconnected",
    PhoneNumberDoNotCall = "PhoneNumberDoNotCall",
    PhoneNumberInvalidNumber = "PhoneNumberInvalidNumber",
    PhoneNumberNotInService = "PhoneNumberNotInService",
    PhoneNumberNotListed = "PhoneNumberNotListed",
    PhoneNumberWrongNumber = "PhoneNumberWrongNumber",
    PhoneNumberUnknownIssue = "PhoneNumberUnknownIssue"
}
export enum PhoneBadNumberIssueModerationDetailsType {
    PhoneBadNumberIssue = "PhoneBadNumberIssue"
}
export enum PhoneNoPrimaryContactsIssueModerationDetailsType {
    PhoneNoPrimaryContactsIssue = "PhoneNoPrimaryContactsIssue"
}
export enum PhoneOnePrimaryContactIssueModerationDetailsType {
    PhoneOnePrimaryContactIssue = "PhoneOnePrimaryContactIssue"
}
export enum PhoneEmergencyNumberAsContactIssueModerationDetailsType {
    PhoneEmergencyNumberAsContactIssue = "PhoneEmergencyNumberAsContactIssue"
}
export enum PsaSafewordReminderDetailsType {
    PsaSafewordReminder = "PsaSafewordReminder"
}
export enum PsaReviewNotificationSettingsDetailsType {
    PsaReviewNotificationSettings = "PsaReviewNotificationSettings"
}
export enum ModerationEventSource {
    Moderation_Tool = "Moderation Tool",
    Monitoring_Insights = "Monitoring Insights",
    Outdoor_Monitoring_Engagement_Handling = "Outdoor Monitoring Engagement Handling"
}
export enum ModerationEventStatus {
    Draft = "Draft",
    Active = "Active",
    Completed = "Completed",
    Failed = "Failed"
}
export enum UpdateModerationEventStatus {
    Active = "Active",
    Completed = "Completed"
}
export enum MonitoringSpecialistActorMonitoringServiceProviderId {
    simplisafe = "simplisafe",
    rrms_internal = "rrms-internal",
    rrms_wholesale = "rrms-wholesale",
    securitas = "securitas",
    unknown = "unknown"
}
export enum SystemStateState {
    Off = "Off",
    Home = "Home",
    Away = "Away",
    Alarm = "Alarm",
    AlarmCount = "AlarmCount",
    Unknown = "Unknown"
}
export enum MotionDetectionType {
    Motion = "Motion"
}
export enum PersonDetectionType {
    Person = "Person"
}
export enum FaceDetectionType {
    Face = "Face"
}
export enum AnalysisState {
    Pending = "Pending",
    Active = "Active",
    Complete = "Complete"
}
export enum VideoRecordingType {
    KVS = "KVS",
    TEP = "TEP",
    MIST = "MIST",
    HLS = "HLS"
}
export enum ComputerVisionDetectionRelevantImageType {
    ComputerVisionDetection = "ComputerVisionDetection"
}
export enum FamiliarFaceTwoWayAudioParticipantType {
    FamiliarFace = "FamiliarFace"
}
export enum FamiliarFaceTwoWayAudioParticipantMatchQuality {
    Match = "Match",
    UnclearMatch = "UnclearMatch",
    NoMatch = "NoMatch"
}
export enum UnfamiliarFaceTwoWayAudioParticipantType {
    UnfamiliarFace = "UnfamiliarFace"
}
export enum CompleteTwoWayAudioInteractionOutdoorActivityResultType {
    CompleteTwoWayAudioInteraction = "CompleteTwoWayAudioInteraction"
}
export enum CompleteTwoWayAudioInteractionOutdoorActivityResultAudioQuality {
    Poor = "Poor",
    Fair = "Fair",
    Good = "Good",
    Other = "Other",
    Unknown = "Unknown"
}
export enum IncompleteTwoWayAudioInteractionOutdoorActivityResultType {
    IncompleteTwoWayAudioInteraction = "IncompleteTwoWayAudioInteraction"
}
export enum IncompleteTwoWayAudioInteractionOutdoorActivityResultReason {
    NeverResponded = "NeverResponded",
    StoppedResponding = "StoppedResponding",
    LivestreamDropped = "LivestreamDropped",
    CouldNotUnderstandDueToLanguageBarrier = "CouldNotUnderstandDueToLanguageBarrier",
    CouldNotUnderstandDueToAudioQuality = "CouldNotUnderstandDueToAudioQuality",
    CouldNotUnderstandDueToOther = "CouldNotUnderstandDueToOther"
}
export enum NoTwoWayAudioInteractionOutdoorActivityResultType {
    NoTwoWayAudioInteraction = "NoTwoWayAudioInteraction"
}
export enum NoTwoWayAudioInteractionOutdoorActivityResultReason {
    Failed = "Failed",
    CommercialException = "CommercialException",
    Other = "Other"
}
export enum OutdoorEngagementResolutionCategory {
    Violence = "Violence",
    ForcedEntry = "ForcedEntry",
    Flames = "Flames",
    VehicleTampering = "VehicleTampering",
    PackageRemoval = "PackageRemoval",
    PropertyDamage = "PropertyDamage",
    MiscSuspiciousBehavior = "MiscSuspiciousBehavior",
    MedicalDistress = "MedicalDistress",
    RequestedPolice = "RequestedPolice",
    RequestedFireDept = "RequestedFireDept",
    RequestedMedicalServices = "RequestedMedicalServices",
    RequestedHelp = "RequestedHelp",
    ClearedBySystemTriage = "ClearedBySystemTriage",
    ClearedByAI = "ClearedByAI",
    ClearedByCustomer = "ClearedByCustomer",
    IntrusionMonitoringTakeover = "IntrusionMonitoringTakeover",
    NoVideoAvailable = "NoVideoAvailable",
    Obsolete = "Obsolete",
    RecentlyArmed = "RecentlyArmed",
    Passerby = "Passerby",
    NeighborActivity = "NeighborActivity",
    UndressedPersonInside = "UndressedPersonInside",
    CameraIsInside = "CameraIsInside",
    IndoorMotion = "IndoorMotion",
    VehicleTraffic = "VehicleTraffic",
    NoPerson = "NoPerson",
    OngoingIncident = "OngoingIncident",
    Delivery = "Delivery",
    PackagePickupUniformed = "PackagePickupUniformed",
    UniformedAuthorities = "UniformedAuthorities",
    UnfamiliarPersonBriefView = "UnfamiliarPersonBriefView",
    VehicleArrivedNobodyExited = "VehicleArrivedNobodyExited",
    LoudOutdoorService = "LoudOutdoorService",
    FamiliarPersonOnProperty = "FamiliarPersonOnProperty",
    UnfamiliarPersonOnProperty = "UnfamiliarPersonOnProperty",
    UnfamiliarUnattendedMinor = "UnfamiliarUnattendedMinor",
    OccupiedVehicleNobodyExited = "OccupiedVehicleNobodyExited",
    Halloween = "Halloween"
}
export enum SystemActorType {
    System = "System"
}
export enum ComputerVisionActorType {
    ComputerVision = "ComputerVision"
}
export enum OutdoorEngagementClearanceEngagementBlock {
    SystemTriage = "SystemTriage",
    ComputerVisionTriage = "ComputerVisionTriage",
    MonitoringSpecialistAssignment = "MonitoringSpecialistAssignment",
    Feed = "Feed",
    Investigate = "Investigate"
}
export enum OutdoorEngagementEscalationNumberOfPeopleObserved {
    None = "None",
    One = "One",
    Two = "Two",
    Several = "Several",
    Unclear = "Unclear"
}
export enum SupersedingEngagementEngagementType {
    Outdoor = "Outdoor"
}
export enum EngagementAssignedOutdoorActivityResultType {
    EngagementAssigned = "EngagementAssigned"
}
export enum EngagementObsoletedOutdoorActivityResultType {
    EngagementObsoleted = "EngagementObsoleted"
}
export enum EngagementResolvedOutdoorActivityResultType {
    EngagementResolved = "EngagementResolved"
}
export enum SupersededOutdoorActivityResultType {
    Superseded = "Superseded"
}
export enum SupersededOutdoorActivityResultActivityType {
    MonitoringSpecialistAssignment = "MonitoringSpecialistAssignment",
    MonitoringSpecialistTriage = "MonitoringSpecialistTriage",
    AutoClearCooldownFromFeed = "AutoClearCooldownFromFeed",
    AutoClearCooldownFromInvestigate = "AutoClearCooldownFromInvestigate",
    QuickClearFromInvestigate = "QuickClearFromInvestigate",
    EscalateToIntrusionWithDescription = "EscalateToIntrusionWithDescription",
    RecentHistory = "RecentHistory",
    TwoWayAudioCheckpoint = "TwoWayAudioCheckpoint",
    FamiliarFaceReviewWithoutAI = "FamiliarFaceReviewWithoutAI",
    TwoWayAudioInteraction = "TwoWayAudioInteraction",
    FinalDocumentation = "FinalDocumentation"
}
export enum AbandonedOutdoorActivityResultType {
    Abandoned = "Abandoned"
}
export enum AbandonedOutdoorActivityResultReason {
    Logout = "Logout",
    WindowClose = "WindowClose",
    ManualNavigation = "ManualNavigation",
    NotCompleteWhenCleared = "NotCompleteWhenCleared",
    SpecialistMismatch = "SpecialistMismatch",
    EngagementAbandoned = "EngagementAbandoned",
    SpecialistConnectionLost = "SpecialistConnectionLost",
    WindowCloseOrRefresh = "WindowCloseOrRefresh",
    ActionTimeout = "ActionTimeout",
    EngagementDropped = "EngagementDropped",
    SynchronizationError = "SynchronizationError",
    Other = "Other"
}
export enum MonitoringSpecialistAssignmentOutdoorActivityType {
    MonitoringSpecialistAssignment = "MonitoringSpecialistAssignment"
}
export enum BouncedOutdoorActivityResultType {
    Bounced = "Bounced"
}
export enum DroppedOutdoorActivityResultType {
    Dropped = "Dropped"
}
export enum NoVideoAvailableOutdoorActivityResultType {
    NoVideoAvailable = "NoVideoAvailable"
}
export enum EngagementPromotedToInvestigateOutdoorActivityResultType {
    EngagementPromotedToInvestigate = "EngagementPromotedToInvestigate"
}
export enum EngagementQuickClearedOutdoorActivityResultType {
    EngagementQuickCleared = "EngagementQuickCleared"
}
export enum MonitoringSpecialistTriageOutdoorActivityType {
    MonitoringSpecialistTriage = "MonitoringSpecialistTriage"
}
export enum CooldownTimerCompletedOutdoorActivityResultType {
    CooldownTimerCompleted = "CooldownTimerCompleted"
}
export enum CooldownManuallyClearedOutdoorActivityResultType {
    CooldownManuallyCleared = "CooldownManuallyCleared"
}
export enum AutoClearCooldownFromFeedOutdoorActivityType {
    AutoClearCooldownFromFeed = "AutoClearCooldownFromFeed"
}
export enum AutoClearCooldownFromInvestigateOutdoorActivityType {
    AutoClearCooldownFromInvestigate = "AutoClearCooldownFromInvestigate"
}
export enum QuickClearFromInvestigateOutdoorActivityType {
    QuickClearFromInvestigate = "QuickClearFromInvestigate"
}
export enum EngagementEscalatedWithDescriptionOutdoorActivityResultType {
    EngagementEscalatedWithDescription = "EngagementEscalatedWithDescription"
}
export enum EscalateToIntrusionWithDescriptionOutdoorActivityType {
    EscalateToIntrusionWithDescription = "EscalateToIntrusionWithDescription"
}
export enum NewIncidentOutdoorActivityResultType {
    NewIncident = "NewIncident"
}
export enum EngagementLinkedWithoutAdditionalHandlingOutdoorActivityResultType {
    EngagementLinkedWithoutAdditionalHandling = "EngagementLinkedWithoutAdditionalHandling"
}
export enum EngagementLinkedWithAdditionalHandlingOutdoorActivityResultType {
    EngagementLinkedWithAdditionalHandling = "EngagementLinkedWithAdditionalHandling"
}
export enum RecentOutdoorMonitoringIncidentLinkability {
    Linkable = "Linkable",
    LinkableWithAdditionalHandling = "LinkableWithAdditionalHandling",
    NotLinkable = "NotLinkable"
}
export enum RecentHistoryOutdoorActivityType {
    RecentHistory = "RecentHistory"
}
export enum TwoWayAudioCheckpointOptionSelectedOutdoorActivityResultType {
    TwoWayAudioCheckpointOptionSelected = "TwoWayAudioCheckpointOptionSelected"
}
export enum TwoWayAudioCheckpointOptionSelectedOutdoorActivityResultSelection {
    Delivery = "Delivery",
    PackagePickupUniformed = "PackagePickupUniformed",
    UnattendedMinor = "UnattendedMinor",
    UniformedAuthorities = "UniformedAuthorities",
    VehicleArrivedNobodyExited = "VehicleArrivedNobodyExited",
    LoudOutdoorService = "LoudOutdoorService",
    PersonLeftView = "PersonLeftView",
    OccupiedVehicleNobodyExited = "OccupiedVehicleNobodyExited",
    Other = "Other"
}
export enum TwoWayAudioCheckpointOutdoorActivityType {
    TwoWayAudioCheckpoint = "TwoWayAudioCheckpoint"
}
export enum FamiliarFacesIdentifiedOutdoorActivityResultType {
    FamiliarFacesIdentified = "FamiliarFacesIdentified"
}
export enum NoFamiliarFacesIdentifiedOutdoorActivityResultType {
    NoFamiliarFacesIdentified = "NoFamiliarFacesIdentified"
}
export enum FamiliarFaceReviewWithoutAIOutdoorActivityType {
    FamiliarFaceReviewWithoutAI = "FamiliarFaceReviewWithoutAI"
}
export enum BaseTwoWayAudioInteractionOutdoorActivityResultType {
    Abandoned = "Abandoned",
    Bounced = "Bounced",
    CooldownManuallyCleared = "CooldownManuallyCleared",
    CooldownTimerCompleted = "CooldownTimerCompleted",
    CompleteTwoWayAudioInteraction = "CompleteTwoWayAudioInteraction",
    Dropped = "Dropped",
    EngagementAssigned = "EngagementAssigned",
    EngagementEscalatedWithDescription = "EngagementEscalatedWithDescription",
    EngagementFinalized = "EngagementFinalized",
    EngagementLinkedWithAdditionalHandling = "EngagementLinkedWithAdditionalHandling",
    EngagementLinkedWithoutAdditionalHandling = "EngagementLinkedWithoutAdditionalHandling",
    EngagementObsoleted = "EngagementObsoleted",
    EngagementPromotedToInvestigate = "EngagementPromotedToInvestigate",
    EngagementQuickCleared = "EngagementQuickCleared",
    EngagementResolved = "EngagementResolved",
    FamiliarFacesIdentified = "FamiliarFacesIdentified",
    IncompleteTwoWayAudioInteraction = "IncompleteTwoWayAudioInteraction",
    NewIncident = "NewIncident",
    NoFamiliarFacesIdentified = "NoFamiliarFacesIdentified",
    NoTwoWayAudioInteraction = "NoTwoWayAudioInteraction",
    NoVideoAvailable = "NoVideoAvailable",
    Superseded = "Superseded",
    TwoWayAudioCheckpointOptionSelected = "TwoWayAudioCheckpointOptionSelected"
}
export enum TwoWayAudioInteractionOutdoorActivityType {
    TwoWayAudioInteraction = "TwoWayAudioInteraction"
}
export enum PeopleObservedRemainedInCameraView {
    RemainedInCameraView = "RemainedInCameraView",
    LeftCameraView = "LeftCameraView"
}
export enum EngagementFinalizedOutdoorActivityResultType {
    EngagementFinalized = "EngagementFinalized"
}
export enum FinalDocumentationOutdoorActivityType {
    FinalDocumentation = "FinalDocumentation"
}
export enum OutdoorActivityCreatedEventType {
    OutdoorActivityCreated = "OutdoorActivityCreated"
}
export enum OutdoorActivityAssignedEventType {
    OutdoorActivityAssigned = "OutdoorActivityAssigned"
}
export enum OutdoorActivityStartedEventType {
    OutdoorActivityStarted = "OutdoorActivityStarted"
}
export enum OutdoorActivityCompletedEventType {
    OutdoorActivityCompleted = "OutdoorActivityCompleted"
}
export enum OutdoorEngagementCreatedEventType {
    OutdoorEngagementCreated = "OutdoorEngagementCreated"
}
export enum OutdoorEngagementAssignedEventType {
    OutdoorEngagementAssigned = "OutdoorEngagementAssigned"
}
export enum OutdoorEngagementResolvedEventType {
    OutdoorEngagementResolved = "OutdoorEngagementResolved"
}
export enum OutdoorEngagementClearedEventType {
    OutdoorEngagementCleared = "OutdoorEngagementCleared"
}
export enum ExistingSafewordType {
    abort = "abort"
}
export enum MonitoringMonitoringServiceProviderId {
    rrms_wholesale = "rrms-wholesale",
    rrms_internal = "rrms-internal",
    securitas = "securitas",
    self_monitored = "self-monitored"
}
export enum USAddressCountry {
    US = "US"
}
export enum GBAddressCountry {
    GB = "GB"
}
export enum SecuritasLocationIdentifiersMonitoringServiceProviderId {
    securitas = "securitas"
}
export enum LocationCameraCombinationCriteriaRuleType {
    LocationCameraCombination = "LocationCameraCombination"
}
